import axios from 'axios'
import jwt from 'jsonwebtoken';
import {
    getFingerprint
} from '@thumbmarkjs/thumbmarkjs'
import notifyIcon from '@/svg/notify.svg'
import "broadcastchannel-polyfill";
import externalComponent from '../utils/external-component';
import AnchorRouterLink from '@/components/VueAnchorRouterLink'
import {
    reconnectAppSync
} from '@/appsync';
import VueMixinTween from 'vue-mixin-tween';
import {
    Navbar,
    DropDown,
    NavLink
} from '@/components';
import {
    mapState
} from 'vuex'
import onPublishMessageSub from "@/graphql/onPublishMessage"
import publishMessage from "@/graphql/publishMessage"
import popMessage from "@/graphql/popMessage"
import createUserMutation from "@/graphql/createUserMutation";
import updateUserMutation from "@/graphql/updateUserMutation";
import updateUserActivityMutation from "@/graphql/updateUserActivityMutation";
import getUserQuery from "@/graphql/getUserQuery";
import signInToForum from "@/graphql/signInToForum"
import getChargebeeSession from "@/graphql/getChargebeeSession"
import getUtilityFunctionsQuery from "@/graphql/getUtilityFunctionsQuery"
import getuserActivityQuery from "@/graphql/getuserActivityQuery"
import pingAPIQuery from "@/graphql/pingAPIQuery";
import getCodeValidation from "@/graphql/getCodeValidation";
const monitoring = () => import('@/components/monitoring');
const userprofile = () => import('@/components/modals/UserProfileModal');
const PurchaseAddonModal = () => import('@/components/modals/purchaseAddons.vue')
const SubscriptionsModal = () => import('@/components/modals/SubscriptionsModal.vue')
const providerRegx = [new RegExp('^SignInWithApple_'), new RegExp('^Google_'), new RegExp('^Facebook_')]
let resizeTimeout;

function resizeThrottler(actualResizeHandler) {
    // ignore resize events as long as an actualResizeHandler execution is in the queue
    if (!resizeTimeout) {
        resizeTimeout = setTimeout(() => {
            resizeTimeout = null;
            actualResizeHandler();

            // The actualResizeHandler will execute at a rate of 15fps
        }, 66);
    }
}
export default {
    name: 'main-navbar',
    beforeMount() {
        let w = this;
        window.pingInProgress = false;
        window.lastPingAttempt = 0;
        window.pingCooldown = 10000; // 10 seconds before another allowed ping attempt
        w.getDeviceMeta()
        let loginRoute = sessionStorage.getItem('loginRoute')
        sessionStorage.removeItem('loginRoute')
        if (loginRoute && w.$route && w.$router) {
            let firstLoginTarget = sessionStorage.getItem('firstLoginTarget')
            sessionStorage.removeItem('firstLoginTarget')
            w.to = firstLoginTarget ? firstLoginTarget : w.username && localStorage.getItem(w.username + ':defaultRoute') ? '/' + localStorage.getItem(w.username + ':defaultRoute') : loginRoute && loginRoute != "/" ? loginRoute : '/calculators'
            //console.log('to', w.to, firstLoginTarget, loginRoute, localStorage.getItem(w.username + ':defaultRoute'))
            if (w.$router && w.$router.resolve({
                    path: w.to
                }) && w.$router.resolve({
                    path: w.to
                }).resolved && w.$router.resolve({
                    path: w.to
                }).resolved.name != 'notfound') {
                w.$router.push(w.to);
            } else {
                if (w.user && w.user.username) {
                    w.$router.push('/calculators')
                } else {
                    w.$router.push('/')
                }
            }
        }
        let value = this.slider.theme && this.slider.theme.value && typeof(this.slider.theme.value) == 'string' ? this.slider.theme.value.toLowerCase() : 'system'
        let genoTheme = this.getInitialColorMode(value)
        localStorage.setItem("genoTheme", genoTheme);
        console.log('init theme', value, genoTheme)
        const darkMode = window.matchMedia('(prefers-color-scheme: dark)');
        darkMode.addListener((event) => {
            console.log('sending toggle theme message');
            this.$eventBus.$emit('appEvents', {
                exec: 'toggleTheme',
                component: 'global'
            })
        });
        w.checkSub('mount');
        setTimeout(() => {
            if (!window.networkOnlineMonitor) {
                console.log('Setting networkOnlineMonitor');
                window.networkOnlineMonitor = true;
                window.addEventListener('online', () => {
                    console.log('[Network] Back online');
                    w.trackActivity({
                        component: "AppSync",
                        function: "online",
                        message: '[Network] Back online '
                    })
                    window.lastPingAttempt = 0;
                    w.checkSub('networkOnlineMonitor online');
                });
                window.addEventListener('offline', () => {
                    console.log('[Network] Went offline');
                    w.trackActivity({
                        component: "AppSync",
                        function: "offline",
                        message: '[Network] Went offline'
                    })
                    window.lastPingAttempt = 0;
                    w.checkSub('networkOnlineMonitor offline');
                });
            }
            const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

            if (connection) {
                console.log('Setting networkConnectionMonitor');
                console.log('Effective connection type:', connection.effectiveType); // '4g', '3g', etc.

                connection.addEventListener('change', () => {
                    console.log('Connection changed:', connection.effectiveType);
                    w.trackActivity({
                        component: "AppSync",
                        function: "connectionChanged",
                        message: connection.effectiveType
                    })
                    window.lastPingAttempt = 0;
                    w.checkSub('networkConnectionMonitor change');
                });
            }
        }, 1000)
        let settings = w.$store.getters.get('settings')
        if (settings && settings.slider) {
            let slider = JSON.parse(JSON.stringify(w.slider))
            Object.keys(settings.slider).map(key => {
                if (!slider[key]) {
                    console.log(`Setting defaults for slider ${key}`)
                    slider[key] = {
                        ...settings.slider[key]
                    }
                }
            })
            w.$store.commit('change', {
                slider: slider
            })
            localStorage.setItem(name, JSON.stringify({
                slider: slider
            }));
        }
    },
    async mounted() {
        if (localStorage.getItem(`lastToast`)) {
            try {
                let now = Date.now()
                let toast = localStorage.getItem(`lastToast`);
                toast = JSON.parse(toast);
                if (toast.timestamp && (now - toast.timestamp) <= 60000) {
                    console.log('Showing toast again')
                    this.showToast(toast);
                } else {
                    console.log('Expired toast')
                }
                localStorage.removeItem(`lastToast`)
            } catch (err) {
                console.log(err)
                localStorage.removeItem(`lastToast`)
            }
        }
        this.loadFeatureScript({
            "id": "dynamic",
            "path": "/js/dynamic.js"
        })
        //this.active = this.$route.to
        if (this.$worker) {
            try {
                let results = await this.$worker.postMessage({
                    action: 'sniff'
                })
                console.log('worker', results)
            } catch (err) {
                console.log('worker err', err)
            }
        }
        var container = document.getElementById('app')
        container.addEventListener('scroll', this.scrollListener)
        this.$store.commit('change', {
            navLoaded: true
        })
        if (localStorage.getItem('genoUpdated') && this.$genoVer) {
            let message = '<b>Changes:</b> ' + this.$genoChanges + '<br>'
            this.$toasted.show(`Genoplot Updated to version: ${this.$genoVer}<br/>${message}`, {
                position: 'top-center',
                duration: 5000,
                type: 'info',
                theme: 'toasted-multiline',
                action: {
                    text: 'OK',
                    onClick: (e, toastObject) => {
                        toastObject.goAway()
                    }
                }
            })
            setTimeout(() => {
                localStorage.removeItem('genoUpdated')
            }, 1000)
        }
        this.$store.commit('change', {
            editingImage: false
        })
        this.$store.commit('change', {
            editedImageUrl: undefined
        })
        if (this.$tempstate) {
            this.$nextTick(() => {
                this.$tempstate.navBar = true;
            })
        }
        if (this.$genericevent) this.$genericevent.boot();
        if (this.username) {
            this.$gtag.customMap({
                'dimension1': 'user'
            })
            this.recordEvent('user_dimension', {
                user: this.username
            })
            this.$gtag.set({
                'user_id': this.username
            })
        }
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
        window.addEventListener('resize', this.handleResize)
        var w = this;
        if (w.$route && w.$route.query && w.$route.query.error_description) {
            let error = w.$route.query.error_description.replace(/^.* ?failed with error /, '')
            w.$router.replace({
                'query': null
            });
            setTimeout(() => {
                w.$modal.show('dialog', {
                    class: 'warning',
                    title: 'Error',
                    text: error
                })
            }, 0)
        }
        setTimeout(() => {
            this.isActive = true;
        }, 500)
        if (window.checkUser) clearInterval(window.checkUser);
        if (window.checkSub) clearInterval(window.checkSub);
        window.checkUser = setInterval(() => {
            if (w.queuedPop) {
                w.popMessage(w.queuedPop)
            }
            let retrying = 0;
            this.checkUserUpdate()
        }, 60000);
        if (!window.CheckSubFunction) {
            console.log("setting network monitor")
            window.CheckSubFunction = true;
            window.checkSub = setInterval(async () => {
                console.debug(`Checking current status ${new Date().toLocaleString()}:${Date.now()}`)
                await w.checkSub('interval');
            }, 30000);
        }
        if (w.$auth) {
            w.$auth.currentAuthenticatedUser()
                .then(async user => {
                    let facebook = user.signInUserSession.idToken.payload['identities'] && user.signInUserSession.idToken.payload['identities'].some(x => x.providerName == 'Facebook') ? true : false
                    //let email = !providerRegx.some(x => x.test(user.username)) && user.attributes && user.attributes.email ? user.attributes.email : user.signInUserSession.idToken.payload["email"] && user.signInUserSession.idToken.payload['identities'] && user.signInUserSession.idToken.payload['identities'][0] && user.signInUserSession.idToken.payload['identities'][0] ? user.signInUserSession.idToken.payload["email"] : user.attributes.email;
                    let email = !providerRegx.some(x => x.test(user.username)) && user.attributes && user.attributes.email ? user.attributes.email : user.signInUserSession.idToken.payload["email"];
                    user.username = !providerRegx.some(x => x.test(user.username)) ? user.username : user.signInUserSession.idToken.payload["preferred_username"] ? user.signInUserSession.idToken.payload["preferred_username"] : user.signInUserSession.idToken.payload['identities'].length ? (facebook ? email.split('@')[0] + 'x' : email.split('@')[0]) : user.username;

                    console.log('username1', user.username)
                    let mfa = user.preferredMFA && user.preferredMFA == "SOFTWARE_TOKEN_MFA" ? true : false
                    if (this.$genericevent) this.$genericevent.update({
                        user_id: this.user.username,
                        MFA: mfa
                    });

                    if (user.attributes) {
                        user.attributes.email = email
                        user.attributes.mfa = mfa
                    } else {
                        user.attributes = {
                            email: email,
                            sub: user.signInUserSession.idToken.payload['sub'] ? user.signInUserSession.idToken.payload['sub'] : '',
                            MFA: mfa
                        }
                    }

                    let groups = user.signInUserSession.idToken.payload["cognito:groups"] || []
                    w.$store.commit('change', {
                        usergroups: groups
                    })
                    if (user.signInUserSession.idToken.payload.forumToken) {
                        let token = user.signInUserSession.idToken.payload.forumToken;
                        w.$store.commit('change', {
                            peeruser: token
                        })
                    } else {
                        w.$store.commit('change', {
                            peeruser: false
                        })
                    }
                    if (user.signInUserSession.idToken.payload.discussToken) {
                        let token = user.signInUserSession.idToken.payload.discussToken
                        document.cookie = `_genod=${token}; domain=.genoplot.com; expires=Sun, 1 Jan 2033 00:00:00 UTC; path=/`
                        w.$store.commit('change', {
                            genod: token
                        })
                    }
                    if (user.signInUserSession.idToken.payload.intercomHash) {
                        let token = user.signInUserSession.idToken.payload.intercomHash
                        w.$store.commit('change', {
                            intercomhash: token
                        })
                    }
                    w.isAdmin = groups.indexOf('admin') >= 0 ? true : false
                    w.$store.commit('change', {
                        isAdmin: w.isAdmin
                    })
                    w.username = user.username;
                    w.proxyuser = user.username;
                    w.usermail = user.attributes.email;
                    w.$store.commit('change', {
                        user: {
                            username: user.username,
                            sub: user.attributes.sub,
                            email: user.attributes.email,
                            MFA: mfa
                        }
                    });
                    if (w.$genericevent) w.$genericevent.shutdown();
                    if (w.$genericevent) w.$genericevent.boot({
                        user_id: w.user.username,
                        name: w.user.username,
                        email: w.user.email,
                        created_at: w.userCreated ? w.userCreated : undefined,
                        Plan: w.subPlan,
                        VIP: w.VIP || false,
                        Credits: w.credits,
                        Renewal: w.renewal,
                        MFA: w.user.MFA,
                        SubRenewal: w.subRenewal,
                        version: w.$genoVer,
                        user_hash: w.intercomhash,
                        last_request_at: parseInt((new Date()).getTime() / 1000)
                    });
                    sessionStorage.setItem('user', JSON.stringify(w.$store.getters.get('user')))
                    w.recordEvent('signedIn', {
                        'event_category': 'authorization',
                        'event_label': w.username
                    })
                    w.updateStatus();
                    if (!w.gtaguser || w.gtaguser !== w.username) {
                        w.$gtag.customMap({
                            'dimension1': 'user'
                        })
                        w.recordEvent('user_dimension', {
                            user: w.username
                        })
                        w.$gtag.set({
                            'user_id': w.username
                        })
                    }
                    w.signedIn = true;
                })
                .catch(() => {
                    w.username = null;
                    w.$store.commit('change', {
                        user: false
                    });
                })
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
        if (window.checkUser) clearInterval(window.checkUser);
        if (window.checkSub) clearInterval(window.checkSub);
        if (window.toastError) {
            window.toastError.goAway()
            delete window.toastError
        }
        if (this.$genericevent) this.$genericevent.shutdown();
        this.$eventBus.$off('appEvents')
        this.$eventBus.$off('authState')
    },
    data() {
        return {
            direction: 'rtl',
            navsrc: false,
            frameDisplay: 'none',
            showNavShare: false,
            spinner: false,
            lastMessagePopTime: 0,
            queuedPop: null,
            active: '/',
            currentScrollValue: 0,
            type: 'white',
            messages: 0,
            lastcredits: 0,
            isAdmin: false,
            state: 0,
            lastSubAttempt: Date.now(),
            lastCreditUpdate: 0,
            isActive: false,
            isToggled: true,
            samplesCount: false,
            subscriptions: {},
            credits: this.$store.getters.get('credits'),
            modals: {
                classic: false
            },
            signedIn: false,
            username: null,
            usermail: null,
            to: this.$route && this.$route.query && this.$route.query.to ? this.$route.query.to : false
        }
    },
    computed: {
        ...mapState({
            genolabs: 'genolabs',
            tosDate: 'tosDate',
            lastQuery: 'lastQuery',
            editingImage: 'editingImage',
            editedImageUrl: 'editedImageUrl',
            editedImageUrl2: 'editedImageUrl2',
            cbloaded: 'cbInstance',
            genoVer: 'genoVer',
            topClass: 'topClass',
            proxyUser: 'proxyUser',
            onLine: 'onLine',
            slider: 'slider',
            subId: 'subId',
            statusMessage: 'statusMessage',
            subscription: 'subscription',
            user: 'user',
            lastUpdate: 'lastUpdate',
            userUpdated: 'userUpdated',
            graphQLurl: 'graphQLurl',
            subsActive: 'subsActive',
            usergroups: 'usergroups',
            subs: 'subscription',
            smallScreen: 'smallScreen',
            intercomhash: 'intercomhash',
            env: 'env'
        }),
        frameClass() {
            return this.src && (this.src.includes('discussions.genoplot') || this.src.includes('devdiscuss.genoplot')) ? 'embedded' : 'normal'
        },
        scriptLoaded: {
            get: function() {
                return this.$store.getters.get('scriptLoaded');
            },
            set: function(value) {
                this.$store.commit('change', {
                    scriptLoaded: value
                })
            },
        },
        showshare: {
            get: function() {
                return this.$store.getters.get('showshare');
            },
            set: function(value) {
                this.$store.commit('change', {
                    showshare: value
                })
            },
        },
        src: {
            get: function() {
                let src = this.$store.getters.get(`sharedurl`) ? this.$store.getters.get(`sharedurl`).split('||')[0] : ''
                return src ? src : false
            },
            set: function(value) {
                this.$store.commit('change', {
                    sharedurl: value
                })
            },
        },
        minScreenWidth() {
            let width = window.screen && window.screen.width ? window.screen.width : 0;
            return width >= 1024 ? true : false
        },
        classes() {
            this.currentScrollValue;
            let color = `bg-${this.type}`;
            let navPosition = `navbar-${this.position}`;
            let colorOnScrollTransparent = this.colorOnScroll && this.currentScrollValue < this.colorOnScroll;
            if (this.position === 'fixed') {
                navPosition = 'fixed-top';
            }

            let classes = [{
                    'navbar-transparent': (this.transparent || colorOnScrollTransparent)
                },
                {
                    [color]: (!this.transparent && this.colorOnScroll === 0 || !this.colorOnScroll)
                },
                navPosition, this.extraNavClasses
            ]
            return classes
        },
        advanced: function() {
            return this.usergroups.indexOf('advanced') >= 0 ? true : false
        },
        dfsid: {
            get: function() {
                return this.$store.getters.get('dftemp')
            },
            set: function(value) {
                this.$store.commit('change', {
                    dfsid: value
                })
            }
        },
        dftoken: {
            get: function() {
                return this.$store.getters.get('dftemp')
            },
            set: function(value) {
                this.$store.commit('change', {
                    dftemp: value
                })
            }
        },
        subType() {
            return this.subs && this.subs.subType && this.subs.subType.indexOf('gold') >= 0 ? 2 : this.subs && this.subs.subType && this.subs.subType.indexOf('silver') >= 0 ? 1 : 0
        },
        contacted: {
            get: function() {
                let w = this;
                let val = this.$store.getters.get('contacted')
                if (val && !w.user) {
                    setTimeout(() => {
                        if (w.$intercom) w.$intercom.showMessages();
                    }, 500)
                }
                return this.$store.getters.get('contacted')
            },
            set: function(value) {
                this.$store.commit('change', {
                    contacted: value
                })
            }
        },
        imageSource: {
            get: function() {
                return this.$store.getters.get('imageSource')
            },
            set: function(value) {
                this.$store.commit('change', {
                    imageSource: value
                })
            }
        },
        alias: {
            get: function() {
                return this.$store.getters.get('alias')
            },
            set: function(value) {
                this.$store.commit('change', {
                    alias: value
                })
            }
        },
        screenWidth: {
            get: function() {
                return this.$store.getters.get('screenWidth')
            },
            set: function(value) {
                this.$store.commit('change', {
                    screenWidth: value
                })
            }
        },
        error: {
            get: function() {
                return this.$store.getters.get('netError')
            },
            set: function(value) {
                this.$store.commit('change', {
                    netError: value
                })
            }
        },
        userstate: {
            get: function() {
                return this.$store.getters.get('userstate')
            },
            set: function(value) {
                this.$store.commit('change', {
                    userstate: value
                })
            }
        },
        updateSampleCount() {
            if (this.user && this.user.username) {
                let samples = this.$store.getters.get('userSamples') ? this.$store.getters.get('userSamples').length : -1
                let rawsamples = this.$store.getters.get('userSamples') ? this.$store.getters.get('userSamples').filter(x => x.type === 'RAW').length : -1
                let calcs = this.$store.getters.get('userCalcs') ? this.$store.getters.get('userCalcs').length : false
                this.calcCount = calcs
                if (samples >= 0) {
                    if (!this.samplesCount || (this.samplesCount && this.samplesCount !== samples)) {
                        if (this.$genericevent) this.$genericevent.update({
                            user_id: this.user.username,
                            Samples: samples,
                            'Raw Samples': rawsamples
                        });
                        this.rawSamplesCount = rawsamples
                        this.samplesCount = samples
                        this.updateStatus();
                    }
                }
                return samples;
            } else {
                return 0
            }
        },
        screenHeight: {
            get: function() {
                return this.$store.getters.get('screenHeight')
            },
            set: function(value) {
                this.$store.commit('change', {
                    screenHeight: value
                })
            }
        },
        handleResize() {
            this.screenWidth = window.innerWidth;
            this.screenHeight = window.innerHeight;
            let small = window.innerWidth < 1024 ? true : false
            this.$store.commit('change', {
                smallScreen: small
            })
        },
        ready() {},
        subscriptionStatus: function() {
            if (this.onLine) {
                //this.reconnect()
                return true
            } else {
                this.disconnect()
                return false
            }
        }
    },
    beforeCreate() {
        let w = this;
        w.$store.commit('change', {
            avatarImage: false
        })
        w.$store.commit('change', {
            spinner: false
        })
        this.broadcast = new BroadcastChannel('update-channel');
        this.broadcast.onmessage = (event) => {
            if (event && event.dat == 'reloadPage') {
                w.refreshPage()
            }
        }
        this.lastCreditUpdate = 0;
        if (!window.onstorage) {
            window.onstorage = () => {
                let signedin = window.localStorage.getItem('CognitoIdentityServiceProvider.7k97gav5nh6fi0ql94lm0io4aj.LastAuthUser') == null ? false : true
                let user = w.user != null && ((typeof(w.user) == 'object' || typeof(w.user) == 'string')) ? true : false
                let currentstate = window.localStorage.getItem('userstate') || 'd'
                let userstate = signedin && !user ? 'a' : user && !signedin ? 'b' : signedin && user && w.user && (window.localStorage.getItem('CognitoIdentityServiceProvider.7k97gav5nh6fi0ql94lm0io4aj.LastAuthUser') != w.user.username) ? 'c' : 'd'

                if (userstate != currentstate) {
                    if (userstate == 'a' || userstate == 'c') {
                        w.$eventBus.$emit('authState', 'signedIn')
                    } else if (userstate == 'b' && w.user && w.user.username) {
                        console.log('Signing out due to storage change')
                        w.signOut()
                        //{ exclude: w.excludeRemote ? w.excludeRemote : 'local' }
                    }
                    window.localStorage.setItem('userstate', userstate)
                }
            };
        }
        this.$eventBus.$on('spinner', info => {
            if (info === 'run') {
                this.spinner = true;
            } else {
                this.spinner = false;
            }
        });
        this.$eventBus.$on('authState', async info => {
            console.log('authState', info)
            let params;
            if (typeof(info) == 'object' && info.modal) {
                params = info.params;
                info = info.modal
            }
            if (info === 'forceLogin' || info === 'signUp' || info === 'signIn' || info === 'signInLocked') {
                this.$modal.show('login', params);
            }

            if (info === 'confirmSignUp' || info === 'signedUp') {
                this.$modal.show('login');
                this.recordEvent('conversion', {
                    'event_category': 'conversion',
                    'event_label': 'success'
                })
            }
            if (info === 'socialSignIn') {
                this.$auth.currentAuthenticatedUser()
                    .then(async user => {
                        //console.log('user social', user);
                        let evt = {}
                        try {
                            evt = {
                                name: user.username,
                                deviceKey: user.signInUserSession.accessToken.payload.device_key,
                            }
                        } catch (err) {
                            console.log('runUtility', err)
                        }
                        let groups = user.signInUserSession.idToken.payload["cognito:groups"] || []
                        let email = !providerRegx.some(x => x.test(user.username)) && user.attributes && user.attributes.email ? user.attributes.email : user.signInUserSession.idToken.payload["email"];
                        user.username = !providerRegx.some(x => x.test(user.username)) ? user.username : user.signInUserSession.idToken.payload["preferred_username"] ? user.signInUserSession.idToken.payload["preferred_username"] : user.signInUserSession.idToken.payload['identities'].length ? (facebook ? email.split('@')[0] + 'x' : email.split('@')[0]) : user.username;
                        let mfa = user.preferredMFA && user.preferredMFA == "SOFTWARE_TOKEN_MFA" ? true : false
                        if (user.attributes) {
                            user.attributes.email = email
                            user.attributes.MFA = mfa
                        } else {
                            user.attributes = {
                                email: email,
                                sub: user.signInUserSession.idToken.payload['sub'] ? user.signInUserSession.idToken.payload['sub'] : '',
                                MFA: mfa
                            }
                        }
                        try {
                            evt.username = user.username
                            evt.subid = user.attributes.sub
                            evt.mfa = user.attributes.MFA
                            this.runUtility(evt);
                        } catch (err) {
                            console.log('runUtility', err)
                        }
                    })
                    .catch(err => {
                        console.log('socialSignIn', err)
                    })
            }
            if (info === 'signedIn') {
                let started = Date.now()
                console.log('user signed in');
                this.$modal.hide('login');
                try {
                    let workerStatus = await this.$worker.postMessage({
                        action: 'sniff'
                    })
                    if (!workerStatus || workerStatus.result !== 1) {
                        if (!this.workerToasted || this.workerToasted > 1) {
                            this.workerToasted = !this.workerToasted ? 1 : this.workerToasted + 1
                            this.$toasted.global.web_worker_error()
                        } else {
                            this.workerToasted++
                        }
                        this.signOut()
                        return;
                    }
                } catch (err) {
                    console.log(err)
                    this.$toasted.global.web_worker_error()
                    this.signOut()
                    return;
                }
                this.dftoken = false;
                this.dfsid = false;
                this.imageSource = '';
                // first login
                if (this.cbInstance) this.cbInstance.logout();
                this.subscriptions = {};
                var init = this.$store.getters.get('init')
                if (init) {
                    try {
                        this.$store.replaceState(JSON.parse(init));
                    } catch (err) {
                        console.log(err)
                    }
                }
                this.$store.commit('change', {
                    init: init
                });
                this.$auth.currentAuthenticatedUser()
                    .then(async user => {
                        //console.log('user', user)
                        let evt = {}
                        try {
                            evt = {
                                name: user.username,
                                deviceKey: user.signInUserSession.accessToken.payload.device_key,
                            }
                        } catch (err) {
                            console.log('runUtility 1', err)
                        }
                        let groups = user.signInUserSession.idToken.payload["cognito:groups"] || []
                        this.$store.commit('change', {
                            usergroups: groups
                        })
                        let facebook = user.signInUserSession.idToken.payload['identities'] && user.signInUserSession.idToken.payload['identities'].some(x => x.providerName == 'Facebook') ? true : false
                        //let email = !providerRegx.some(x => x.test(user.username)) && user.attributes && user.attributes.email ? user.attributes.email : user.signInUserSession.idToken.payload["email"] && user.signInUserSession.idToken.payload['identities'] && user.signInUserSession.idToken.payload['identities'][0] && user.signInUserSession.idToken.payload['identities'][0] ? user.signInUserSession.idToken.payload["email"] : user.attributes.email;
                        let email = !providerRegx.some(x => x.test(user.username)) && user.attributes && user.attributes.email ? user.attributes.email : user.signInUserSession.idToken.payload["email"];
                        user.username = !providerRegx.some(x => x.test(user.username)) ? user.username : user.signInUserSession.idToken.payload["preferred_username"] ? user.signInUserSession.idToken.payload["preferred_username"] : user.signInUserSession.idToken.payload['identities'].length ? (facebook ? email.split('@')[0] + 'x' : email.split('@')[0]) : user.username;
                        let mfa = user.preferredMFA && user.preferredMFA == "SOFTWARE_TOKEN_MFA" ? true : false
                        if (user.attributes) {
                            user.attributes.email = email
                            user.attributes.MFA = mfa
                        } else {
                            user.attributes = {
                                email: email,
                                sub: user.signInUserSession.idToken.payload['sub'] ? user.signInUserSession.idToken.payload['sub'] : '',
                                MFA: mfa
                            }
                        }
                        try {
                            evt.username = user.username
                            evt.subid = user.attributes.sub
                            evt.mfa = user.attributes.MFA
                            this.runUtility(evt);
                        } catch (err) {
                            console.log('runUtility 2', err)
                        }
                        if (user.signInUserSession.idToken.payload.forumToken) {
                            let token = user.signInUserSession.idToken.payload.forumToken;
                            this.$store.commit('change', {
                                peeruser: token
                            })
                        } else {
                            this.$store.commit('change', {
                                peeruser: false
                            })
                        }
                        if (user.signInUserSession.idToken.payload.discussToken) {
                            let token = user.signInUserSession.idToken.payload.discussToken
                            document.cookie = `_genod=${token}; domain=.genoplot.com; expires=Sun, 1 Jan 2033 00:00:00 UTC; path=/`
                            this.$store.commit('change', {
                                genod: token
                            })
                        }
                        if (user.signInUserSession.idToken.payload.intercomHash) {
                            let token = user.signInUserSession.idToken.payload.intercomHash
                            this.$store.commit('change', {
                                intercomhash: token
                            })
                        }
                        this.isAdmin = groups.indexOf('admin') >= 0 ? true : false
                        this.$store.commit('change', {
                            isAdmin: this.isAdmin
                        })
                        //currentSession().then(data => console.log("JWT", data.getAccessToken().getJwtToken()));
                        this.username = user.username;
                        this.proxyuser = user.username;
                        let firstLoginTarget = localStorage.getItem('firstLoginTarget')
                        if (firstLoginTarget) localStorage.removeItem('firstLoginTarget')
                        this.to = this.$route.path == '/' ? (firstLoginTarget ? firstLoginTarget : this.$store.getters.get('target') ? this.$store.getters.get('target') : this.username && localStorage.getItem(this.username + ':defaultRoute') ? '/' + localStorage.getItem(this.username + ':defaultRoute') : '/calculators') : this.$route.path == '/discussions' ? window.location.pathname : this.$route.path
                        console.log('to', this.$route.path, this.to, this.$store.getters.get('target'), localStorage.getItem(this.username + ':defaultRoute'))
                        this.usermail = user.attributes.email;
                        this.$store.commit('change', {
                            user: {
                                username: user.username,
                                sub: user.attributes.sub,
                                email: email,
                                MFA: mfa
                            }
                        });
                        this.$eventBus.$emit('appEvents', {
                            exec: 'reloadForum',
                            component: 'discussions',
                            params: 'force'
                        })
                        sessionStorage.setItem('user', JSON.stringify(this.$store.getters.get('user')))
                        this.recordEvent('signedIn', {
                            'event_category': 'authorization',
                            'event_label': this.username
                        })
                        if (!this.gtaguser || this.gtaguser !== this.username) {
                            this.$gtag.customMap({
                                'dimension1': 'user'
                            })
                            this.recordEvent('user_dimension', {
                                user: this.username
                            })
                            this.$gtag.set({
                                'user_id': this.username
                            })
                        }
                        this.gtaguser = this.username
                        await this.getUser(this.username);
                        this.signedIn = true;
                        if (this.to) {
                            if (this.$router.resolve({
                                    path: this.to
                                }) && this.$router.resolve({
                                    path: this.to
                                }).resolved && this.$router.resolve({
                                    path: this.to
                                }).resolved.name != 'notfound') {
                                this.$router.push(this.to);
                            } else {
                                if (this.user && this.user.username) {
                                    this.$router.push('/calculators')
                                } else {
                                    this.$router.push('/')
                                }
                            }
                        }
                        this.checkUserUpdate();
                        if (!(this.subscriptions && this.subscriptions['genoplot:user:' + user.username])) this.pubsub('genoplot:user:' + user.username, 0);
                        if (!(this.subscriptions && this.subscriptions['genoplot:broadcast'])) this.pubsub('genoplot:broadcast', 0);
                        if ((this.$store.getters.get('env') !== 'production') && !(this.subscriptions && this.subscriptions['genoplot:broadcast:staging'])) this.pubsub('genoplot:broadcast:staging', 0);
                        this.updateStatus();
                        if (this.$genericevent) this.$genericevent.shutdown();
                        if (this.$genericevent) this.$genericevent.boot({
                            user_id: this.user.username,
                            name: this.user.username,
                            email: this.user.email,
                            created_at: this.userCreated ? this.userCreated : undefined,
                            Plan: this.subPlan,
                            VIP: this.VIP || false,
                            Credits: this.credits,
                            Renewal: this.renewal,
                            SubRenewal: this.subRenewal,
                            version: this.$genoVer,
                            user_hash: this.intercomhash,
                            MFA: this.user.MFA,
                            last_request_at: parseInt((new Date()).getTime() / 1000)
                        });
                    })
                    .catch(() => {
                        this.username = null;
                        this.$store.commit('change', {
                            user: false
                        });
                        this.to = this.$route && this.$route.query && this.$route.query.to ? this.$route.query.to : false
                        if (this.to) this.$modal.show('login');
                    })
            }
            if (info === 'signedOut') {
                if (this.cbInstance) this.cbInstance.logout();
                this.signedIn = false,
                    this.subscriptions = {};
                this.lastuser = this.username;
                this.username = null
                this.$store.commit('change', {
                    user: null
                });
                document.cookie = `_genod=; domain=.genoplot.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
                this.$store.commit('change', {
                    genod: false
                })
                this.$store.commit('change', {
                    intercomhash: false
                })
                sessionStorage.removeItem('user')
                this.$store.commit('change', {
                    peeruser: null
                })
                if (this.$route.meta && this.$route.meta.requiresAuth) {
                    this.$router.push('/')
                }
            }
            this.trackAuth(info);
        });
        this.$auth.currentAuthenticatedUser()
            .then(user => {
                let groups = user.signInUserSession.idToken.payload["cognito:groups"] || []
                this.isAdmin = groups.indexOf('admin') >= 0 ? true : false
                this.$store.commit('change', {
                    isAdmin: this.isAdmin
                })
                let facebook = user.signInUserSession.idToken.payload['identities'] && user.signInUserSession.idToken.payload['identities'].some(x => x.providerName == 'Facebook') ? true : false
                //let email = !providerRegx.some(x => x.test(user.username)) && user.attributes && user.attributes.email ? user.attributes.email : user.signInUserSession.idToken.payload["email"] && user.signInUserSession.idToken.payload['identities'] && user.signInUserSession.idToken.payload['identities'][0] && user.signInUserSession.idToken.payload['identities'][0] ? user.signInUserSession.idToken.payload["email"] : user.attributes.email;
                let email = !providerRegx.some(x => x.test(user.username)) && user.attributes && user.attributes.email ? user.attributes.email : user.signInUserSession.idToken.payload["email"];
                user.username = !providerRegx.some(x => x.test(user.username)) ? user.username : user.signInUserSession.idToken.payload["preferred_username"] ? user.signInUserSession.idToken.payload["preferred_username"] : user.signInUserSession.idToken.payload['identities'].length ? (facebook ? email.split('@')[0] + 'x' : email.split('@')[0]) : user.username;
                this.$store.commit('change', {
                    usergroups: groups
                })
                let mfa = user.preferredMFA && user.preferredMFA == "SOFTWARE_TOKEN_MFA" ? true : false
                if (user.attributes) {
                    user.attributes.email = email
                    user.attributes.MFA = mfa
                } else {
                    user.attributes = {
                        email: email,
                        sub: user.signInUserSession.idToken.payload['sub'] ? user.signInUserSession.idToken.payload['sub'] : '',
                        MFA: mfa
                    }
                }
                this.username = user.username;
                this.proxyuser = user.username;
                this.usermail = email
                this.signedIn = true
                this.checkUserUpdate();
                //this.pubsub('genoplot:user:' + user.username, 0);
                //this.pubsub('genoplot:broadcast', 0);
                //if (this.$store.getters.get('env') !== 'production') this.pubsub('genoplot:broadcast:staging', 0);
                if (!(this.subscriptions && this.subscriptions['genoplot:user:' + user.username])) this.pubsub('genoplot:user:' + user.username, 0);
                if (!(this.subscriptions && this.subscriptions['genoplot:broadcast'])) this.pubsub('genoplot:broadcast', 0);
                if ((this.$store.getters.get('env') !== 'production') && !(this.subscriptions && this.subscriptions['genoplot:broadcast:staging'])) this.pubsub('genoplot:broadcast:staging', 0);
                this.$modal.hide('login');
                this.$store.commit('change', {
                    user: {
                        username: user.username,
                        sub: user.attributes.sub,
                        email: user.attributes.email
                    }
                });
                sessionStorage.setItem('user', JSON.stringify(this.$store.getters.get('user')))
                this.getUser(this.username);
                if (this.$genericevent) this.$genericevent.update({
                    user_id: this.user.username,
                    MFA: mfa
                });

            })
            .catch((err) => {
                console.log('Not authenticated', err);
                this.to = this.$route && this.$route.query && this.$route.query.to ? this.$route.query.to : false
                this.signOut()
            })
    },
    async created() {
        let w = this;
        this.imageSource = '';
        let baseurl = (this.$store.getters.get('env') === 'staging' || this.$store.getters.get('env') === 'development') ? `https://devdiscuss.genoplot.com` : `https://discussions.genoplot.com`
        this.imgsrc = `${baseurl}/assets/images/ping.png?v=${Date.now()}`
        this.scriptLoaded = false
        this.messages = 0;
        this.$eventBus.$on('appEvents', info => {
            this.trackAppEvents(info);
            if (typeof(info) === 'object' && info.component === 'nav') {
                var exec = info.exec;
                if (exec === 'execError') {
                    console.log(err)
                    return;
                }
                try {
                    this[exec](info.params)
                } catch (err) {
                    console.error('error: ', err)
                }
            } else {
                if (typeof(info) === 'object' && info.exec === 'refreshCacheSaved') {
                    localStorage.setItem('cacheVer', JSON.stringify(info.params))
                    w.refreshCache(info.params)
                }
            }
        })
        /*if (!window['zE']) {
            this.$zendesk.load()
        } else {
            zE('webWidget', 'show')
        }
        this.$on('zendeskLoaded', (event) => {
            if (this.signedIn) {
                if (window['zE']) {
            zESettings = { webWidget:{ contactForm: { fields: [ { id: 360047623713, prefill: { '*': w.subType === 2 ? 'PRO' :  w.subType === 1 ? 'BASIC' : 'FREE' } } ], tags: [w.username, w.subType === 2 ? 'PRO' :  w.subType === 1 ? 'BASIC' : 'FREE' ] }}}
                let identity = {
                  name: w.user && w.user.username ? w.user.username : w.username ? w.username : '',
                      email: w.usermail,
                            }
            this.$zendesk.identify(identity);
            this.$zendesk.prefill({
                        name: {
                            value: w.username,
                            readOnly: true // optional
                        },
                        Subscription: {
                        value: w.subType === 2 ? 'PRO' :  w.subType === 1 ? 'BASIC' : 'FREE'
                        },
                        email: {
                            value: w.usermail,
                            readOnly: true // optional
                        }
                    })
                    setTimeout(() => {
                        zE('webWidget', 'show')
                    }, 2000)
                }
            }
        })
        ! function(e, t, n, s, u, a) {
            e.twq || (s = e.twq = function() {
                    s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
                }, s.version = '1.1', s.queue = [], u = t.createElement(n), u.async = !0, u.src = '//static.ads-twitter.com/uwt.js',
                a = t.getElementsByTagName(n)[0], a.parentNode.insertBefore(u, a))
        }(window, document, 'script');
        // Insert Twitter Pixel ID and Standard Event data below
        twq('init', 'o4ka6');
        twq('track', 'PageView');
        */
    },
    props: {
        transparent: Boolean,
        colorOnScroll: Number,
        component: String,
        position: String
    },
    components: {
        Navbar,
        notifyIcon,
        NavLink,
        DropDown,
        userprofile,
        AnchorRouterLink,
        PurchaseAddonModal,
        SubscriptionsModal,
        monitoring
    },
    mixins: [
        VueMixinTween('credits', 100, (pos) => pos)
    ],
    methods: {
        onLoad: function(evt) {
            console.log('loaded', evt)
            if (evt.target.src != '') {
                this.frameDisplay = 'block'
                this.spinner = false;
                this.frameReady = true
                this.saveReady2 = true
            }
        },
        async checkSub(evt) {
            const now = Date.now();
            if (window.pingInProgress || (now - window.lastPingAttempt < window.pingCooldown)) {
                console.debug('[Network Ping] Skipped due to cooldown or in progress');
                return;
            }
            window.pingInProgress = true;
            window.lastPingAttempt = now;
            console.debug('Checking subscription', evt);
            let w = this;
            if (w.user) {
                try {
                    console.debug('Testing API connectivity...')
                    let data = await w.$apollo.query({
                        query: pingAPIQuery,
                        context: {
                            timeout: 15000
                        },
                        fetchPolicy: 'network-only'
                    })
                    window.pingInProgress = false;
                    if (data && data.data && data.data.pingAPI) {
                        if (window.toastError) {
                            window.toastError.goAway()
                            delete window.toastError
                        }
                        if (!w.onLine) {
                            w.$store.commit('change', {
                                onLine: true
                            })
                            w.trackActivity({
                                component: "AppSync",
                                function: "reconnectedAPI",
                                message: `Recovered from graphql error: ${w.error}`
                            })
                            w.reconnect();
                        }
                    }
                } catch (err) {
                    window.pingInProgress = false;
                    console.debug(err && err.message ? err.message.substr(0, 256) : err);
                    w.$store.commit('change', {
                        netError: err && err.message ? err.message.substr(0, 256) : err
                    })
                    if (!err || !err.message || err && err.message && !err.message.includes('pingerAPI')) {
                        if (w.onLine) {
                            w.$store.commit('change', {
                                onLine: false
                            })
                            w.disconnect()
                        } else {
                            w.disconnect()
                        }
                        console.log('Network timeout!')
                    }
                }
            } else {
                try {
                    let data = await axios.head('/ping.ico?version=' + Date.now(), {})
                    window.pingInProgress = false;
                    if (data && data.status && data.status == 200) {
                        if (window.toastError) {
                            window.toastError.goAway()
                            delete window.toastError
                        }
                        if (!w.onLine) {
                            w.$store.commit('change', {
                                onLine: true
                            })
                            w.trackActivity({
                                component: "AppSync",
                                function: "reconnected",
                                message: `Recovered from network error: ${w.error}`
                            })
                            w.$store.commit('change', {
                                netError: undefined
                            })
                        }
                    }
                } catch (err) {
                    window.pingInProgress = false;
                    w.$store.commit('change', {
                        netError: err
                    })
                    if (w.onLine) {
                        w.$store.commit('change', {
                            onLine: false
                        })
                        w.disconnect()
                    } else {
                        w.disconnect()
                    }
                    console.log('Network timeout!')
                }
            }
        },
        requiresSub(option) {
            let w = this;
            let buttons = [{
                title: 'Cancel',
                default: true,
                handler: () => {
                    w.closable = false;
                    w.$modal.hide('dialog');
                } // Button click handler
            }]
            if (w.subType == 0) {
                buttons.unshift({
                    title: 'Subscribe',
                    handler: () => {
                        w.createNew = false;
                        w.$modal.hide('dialog');
                        w.recordEvent('subButtonAnalyze', {
                            'event_category': 'function',
                            'event_label': 'User initiated'
                        })
                        w.$eventBus.$emit('appEvents', {
                            exec: 'checkSubStatus',
                            component: 'nav',
                        })
                    } // Button click handler
                })
            }
            w.$modal.show('dialog', {
                title: 'History is a premium feature',
                text: "Subscribers can access the timeline of all previously saved nMonte models, calculator runs, and PCA plots.<br><br>The saved history can be searched and models, calculators and plots can be <b>replayed</b> or <b>viewed</b> as desired.<br>",
                class: 'alert',
                buttons: buttons
            })
        },
        startAdmixTour() {
            this.$router.push({
                name: 'admix',
                params: {
                    index: 0
                }
            })
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$eventBus.$emit('appEvents', {
                        exec: 'startTour',
                        component: 'admix',
                    })
                }, 2000)
            })
        },
        closeDrawer: function() {
            this.showshare = false
            this.spinner = false
            this.embed = false
            this.src = false;
            this.frameDisplay = 'none'
            this.saveReady2 = false
        },
        async popMessage(timestamp) {
            let w = this;
            w.lastMessagePopTime = w.lastMessagePopTime || 0
            w.queuedPop = null;
            w.lastMessagePopTime = Date.now()
            try {
                let data = await w.$apollo.mutate({
                    mutation: popMessage,
                    variables: {
                        user: w.user.username,
                        timestamp: timestamp
                    },
                    fetchPolicy: 'no-cache'
                })
                if (data && data.data && data.data.popMessage && data.data.popMessage.message) {
                    let message = JSON.parse(data.data.popMessage.message);
                    let eparams = {
                        className: 'toastDiaabledUser toastError',
                        message: message.text.substr(0, 4) == '<br>' ? (new Date(timestamp)).toLocaleString() + message.text : message.text,
                        duration: message.duration,
                        toast: true,
                        force: message.force,
                        delay: message.delay,
                        button: message.button,
                        swipe: message.swipe,
                        countdown: message.countdown,
                        clear: message.clear,
                        icon: 'check',
                        position: 'top-center',
                        action: message.action,
                        timestamp: timestamp
                    }
                    eparams.params = message.params
                    if (w[message.action]) {
                        let options = {
                            mutation: publishMessage,
                            variables: {
                                message: {
                                    id: `genoplot:user:${w.user.username}`,
                                    message: JSON.stringify({
                                        action: 'execToast',
                                        params: eparams,
                                        component: 'nav'
                                    })
                                }
                            },
                            fetchPolicy: 'no-cache'
                        }
                        const exec = await w.$apollo.mutate(options)
                    } else {
                        console.log('Action: ' + message.action + ' not found')
                    }
                } else {
                    console.log('No message received')
                }
            } catch (err) {
                console.log('popMessage', err);
            }
        },
        updateFeatureScript(params) {
            let path = params.path
            let id = params.id
            const existingScript = document.getElementById(id);
            if (existingScript) {
                existingScript.remove();
                console.log(`Removed existing script with id "${id}"`);
            }

            const newScript = document.createElement('script');
            newScript.src = `${path}?v=${new Date().getTime()}`; // Cache-busted URL
            newScript.id = id; // Assign the same id
            newScript.type = 'text/javascript';
            newScript.onload = () => console.log(`Script "${id}" reloaded`);
            newScript.onerror = () => console.error(`Failed to reload script "${id}"`);
            document.head.appendChild(newScript);
        },
        loadFeatureScript(params) {
            let path = params.path
            let id = params.id
            const existingScript = document.getElementById(id);
            if (existingScript) {
                console.log(`Script with id "${id}" already exists.`);
                return;
            }
            const script = document.createElement('script');
            script.src = `${path}?v=${new Date().getTime()}`; // Cache-busted URL
            script.id = id; // Assign the id
            script.type = 'text/javascript';
            script.onload = () => console.log(`${path} loaded with id "${id}"`);
            script.onerror = () => console.error(`Failed to load ${path}`);
            document.head.appendChild(script);
        },
        async verifyJWT(token, key) {
            let w = this;
            return new Promise((resolve, reject) => {
                try {
                    jwt.verify(token, key, function(err, verified) {
                        resolve(verified)
                    })
                } catch (err) {
                    console.log(err)
                    resolve({})
                }
            })
        },
        verifyToken: async function(params) {
            let w = this;
            w.$store.commit('change', {
                spinner: true
            })
            if (!w.user.MFA) {
                w.$modal.show('userprofile', {
                    requireMFA: true,
                    allowMfaClose: true,
                    mfaMessage: 'Multifactor Authentication is required to use this feature'
                })
                w.$store.commit('change', {
                    spinner: false
                })
            } else if (params.token) {
                try {
                    let component = params.token;
                    let token = sessionStorage.getItem(params.token)
                    token = JSON.parse(token)
                    let key = token ? token.public : token
                    key = key ? atob(key) : key
                    token = token ? token.jwt : token
                    if (token) {
                        let expired = true;
                        let verified
                        if (key) {
                            verified = await w.verifyJWT(token, key)
                        }
                        if (verified && verified.exp && verified.exp > Math.ceil(Date.now() / 1000)) {
                            expired = false;
                        } else if (verified && verified.exp && verified.exp < Math.ceil(Date.now() / 1000)) {
                            delete params.token
                            return params
                        } else {
                            verified = await w.$apollo.query({
                                query: getCodeValidation,
                                variables: {
                                    component: component,
                                    token: token
                                },
                                fetchPolicy: 'network-only'
                            })
                            if (verified && verified.data && verified.data.getCodeValidation && verified.data.getCodeValidation.isAuthorized == 'true') {
                                expired = false
                            };
                        }
                        if (!expired) {
                            //console.log('Success')
                            w.$store.commit('change', {
                                spinner: false
                            })
                            if (params.exec && params.exec.action && params.exec.method) {
                                params.exec.method({
                                    action: params.exec.action,
                                    mfapassed: true,
                                    component: component,
                                    token: token,
                                })
                            } else if (params.next && !params.action) {
                                params.next()
                            } else if (params.next && params.action && params.action.route) {
                                params.next({
                                    name: params.action.route
                                })
                                return false
                            } else {
                                delete params.token
                                return params
                            }
                        } else {
                            w.$store.commit('change', {
                                spinner: false
                            })
                            delete params.token
                            return params
                        }
                    } else {
                        w.$store.commit('change', {
                            spinner: false
                        })
                        delete params.token
                        return params
                    }
                } catch (err) {
                    console.log(err);
                    w.$store.commit('change', {
                        spinner: false
                    })
                    delete params.token
                    return params
                }
            } else {
                w.$store.commit('change', {
                    spinner: false
                })
                return params;
            }
        },
        trackActivity: async function(evt) {
            if ( this.user && this.user.username &&  this.onLine ) {
            let status = {}
            status.action = 'trackActivity';
            status.mode = 'async';
            status.component = evt.component;
            status.function = evt.function;
            status.userid = this.user.username
            status.lastactivity = Math.round(Date.now() / 1000);
            status.credits = this.credits;
            status.planType = this.subPlan;
            status.version = this.$genoVer;
            if (this.subscription && this.subscription.renewal) status.renewal = this.subscription.renewal
            if (this.subscription && this.subscription.subRenewal) status.subRenewal = this.subscription.subRenewal
            if (this.rawSamplesCount) status.rawsamples = this.rawSamplesCount
            if (this.samplesCount) status.samples = this.samplesCount
            if (this.calcCount) status.calculators = this.calcCount
            if (this.$route && this.$route.name) status.route = this.$route.name
            if (this.alias) status.nickname = this.alias
            try {
                let theme = this.slider.theme && this.slider.theme.value && typeof(this.slider.theme.value) == 'string' ? this.slider.theme.value.toLowerCase() : 'system'
                status.theme = theme;
                status.mode = 'async';
                status.action = 'trackActivity';
                status.component = evt.component;
                status.function = evt.function;
                status.recovery = evt.message
                let meta = localStorage.getItem('devicemeta')
                try {
                    let ranutility = localStorage.getItem(`ranUtility:${status.userid}`)
                    if (ranutility) {
                        ranutility = JSON.parse(ranutility);
                        status.deviceKey = ranutility.deviceKey
                        status.mfa = ranutility.mfa
                        status.name = ranutility.name
                    }
                    meta = meta ? JSON.parse(meta) : undefined
                    if (!meta || !meta.ip) {
                        await this.getDeviceMeta();
                        meta = localStorage.getItem('devicemeta')
                    } else {
                        meta = JSON.stringify(meta)
                    }
                } catch (err) {
                    console.log('meta err', err)
                }
                status.meta = meta
                let fp = undefined
                if (this.thumbmark) {
                    fp = this.thumbmark
                } else {
                    try {
                        fp = await getFingerprint()
                        this.thumbmark = fp;
                        let end = Date.now()
                    } catch (err) {
                        console.log('fp err', err)
                    }
                }
                status.fp = fp;
                let query = getuserActivityQuery;
                const data = await this.$apollo.query({
                    query: query,
                    variables: {
                        event: JSON.stringify(status)
                    },
                    fetchPolicy: 'network-only'
                })
            } catch (err) {
                console.log(err);
            }
            }
        },
        runUtility: async function(evt) {
            try {
                let username = evt.username;
                let version = this.$genoVer
                let subscription = this.$store.getters.get('subscription')
                let name = evt.name;
                let mfa = evt.mfa;
                let deviceKey = evt.deviceKey;
                let subid = evt.subid
                let query = getUtilityFunctionsQuery;
                let meta = localStorage.getItem('devicemeta')
                try {
                    meta = meta ? JSON.parse(meta) : undefined
                    if (!meta || !meta.ip) {
                        await this.getDeviceMeta();
                        meta = localStorage.getItem('devicemeta')
                    } else {
                        meta = JSON.stringify(meta)
                    }
                } catch (err) {
                    console.log('meta err', err)
                }
                let forceMFA = subscription && subscription.mfaForced ? true : false
                let remember = forceMFA ? false : localStorage.getItem('genoplot:remember-device') ? true : false
                let event = {
                    mode: "async",
                    deviceKey: deviceKey,
                    username: username,
                    name: name,
                    subid: subid,
                    mfa: mfa,
                    refresh: evt.getUser || false,
                    meta: meta,
                    version: version,
                    remember: remember
                }
                let ranutility = localStorage.getItem(`ranUtility:${event.username}`)
                let runquery = true;
                try {
                    if (ranutility) {
                        ranutility = JSON.parse(ranutility);
                        let timeago = Date.now() - 600000
                        if (ranutility.username == event.username && ranutility.remember == event.remember && (evt.getUser || timeago < ranutility.timestamp)) {
                            runquery = false
                        }
                        if (ranutility.version != event.version || ranutility.user != event.user) runquery = true;
                    }
                } catch (err) {
                    console.log('ranutility err', err)
                }
                let newEvent = {
                    ...event
                }
                newEvent.timestamp = Date.now()
                if (runquery) {
                    let fp = undefined
                    let start = Date.now()
                    if (this.thumbmark) {
                        fp = this.thumbmark
                    } else {
                        try {
                            fp = await getFingerprint()
                            this.thumbmark = fp;
                            let end = Date.now()
                            console.log(`Fingerprinted in ${end - start} ms`, fp)
                        } catch (err) {
                            console.olog('fp err', err)
                        }
                    }
                    event.fp = fp;
                    const data = await this.$apollo.query({
                        query: query,
                        variables: {
                            event: JSON.stringify(event)
                        },
                        fetchPolicy: 'network-only'
                    })
                    console.log('data runUtility', data)
                    localStorage.setItem(`ranUtility:${event.username}`, JSON.stringify(newEvent));
                    this.broadcast.postMessage('checkUpdates');
                } else {
                    console.log('No need to run utility function')
                    this.broadcast.postMessage('checkUpdates');
                }
            } catch (err) {
                console.log('err runUtility', err)
            }
        },
        getDeviceMeta: async function() {
            try {
                let meta;
                let fp = this.thumbmark ? this.thumbmark : await getFingerprint();
                this.thumbmark = fp;
                meta = await axios.get("https://genoplot.com/device", {
                    headers: {
                        genotoken: "hlhjyui2jkjkj7lkkll",
                        fp: fp
                    }
                })
                if (meta && meta.data) {
                    if (fp) meta.data.fp = fp;
                    localStorage.setItem('devicemeta', JSON.stringify(meta.data))
                }
            } catch (err) {
                console.log('meta', err)
            }
        },
        refreshCache(newcache) {
            return;
            let w = this;
            let cachingRoutes = ['/g25', '/admix', '/calculators', '/pca']
            let stage = this.$store.getters.get('env') === 'production' ? '' : 'staging/';
            if (cachingRoutes.findIndex(x => x.includes(w.$route.name)) < 0) {
                let cache = typeof(newcache) !== 'undefined' ? newcache : localStorage.getItem('cacheVer') ? JSON.parse(localStorage.getItem('cacheVer')) : {
                    groups: {
                        g25: currentDT
                    },
                    samples: currentDT,
                    tos: 0,
                    calcVersion: currentDT
                }
                this.$dbCache.getAll(cache, 'nav global', stage, [])
            }
        },
        setOnline() {
            console.log('setting discussions to true')
            this.scriptLoaded = true;
        },
        getInitialColorMode(value) {
            const persistedColorPreference = value == 'system' ? false : value
            const hasPersistedPreference = typeof persistedColorPreference === 'string';
            if (hasPersistedPreference) {
                this.setColors(persistedColorPreference)
                return persistedColorPreference;
            }
            const mql = window.matchMedia('(prefers-color-scheme: dark)');
            const hasMediaQueryPreference = typeof mql.matches === 'boolean';
            if (hasMediaQueryPreference) {
                this.setColors(mql.matches ? 'dark' : 'light')
                return mql.matches ? 'dark' : 'light';
            }
            this.setColors('light')
            return 'light';
        },
        setColors(value) {
            if (value == 'dark') {
                document.documentElement.style.setProperty('--bg-color', '#181818');
                document.documentElement.style.setProperty('--color', '#dfdfdf');
                document.documentElement.style.setProperty('color-scheme', 'dark');
            } else {
                document.documentElement.style.setProperty('--bg-color', '#f2f2f2');
                document.documentElement.style.setProperty('--color', '#444444');
                document.documentElement.style.setProperty('color-scheme', 'light');
            }
        },
        scrollListener() {
            resizeThrottler(this.handleScroll)
        },
        handleScroll() {
            const container = document.getElementById('app')
            let scrollValue = container.scrollTop || window.scrollY
            this.currentScrollValue = scrollValue;
            let colorOnScroll = this.colorOnScroll == -1 ? window.innerHeight - 75 : this.colorOnScroll
            if (colorOnScroll > 0 && scrollValue > colorOnScroll) {
                this.extraNavClasses = `bg-${this.type}`;
            } else {
                if (this.extraNavClasses) {
                    this.extraNavClasses = ''
                }
            }
        },
        resetMessages() {
            console.log('resetting messages');
            let w = this;
            w.messages = 0;
            let user = {
                userid: w.user.username,
                notifications: 0
            }
            w.updateUser(user);
        },
        logoutForum() {
            let w = this;
            document.cookie = `_genod=; domain=.genoplot.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
            this.$store.commit('change', {
                genod: false
            })
            w.$eventBus.$emit('appEvents', {
                exec: 'reloadForum',
                component: 'discussions',
            })
        },
        checkCookie: async function(avatar) {
            let w = this;
            let name = '_genod'
            let cookie = (document.cookie.match('(?:^|;)\\s*' + name.trim() + '\\s*=\\s*([^;]*?)\\s*(?:;|$)') || [])[1];
            if (w.user && w.user.username) {
                let data = await w.$apollo.query({
                    query: signInToForum,
                    variables: {
                        username: w.user.username,
                        email: w.user.email,
                        avatar: avatar ? avatar : w.subscription.avatar || ' ',
                    },
                    fetchPolicy: 'network-only'
                })
                if (data && data.data && data.data.signInToForum && data.data.signInToForum.result && data.data.signInToForum.result) {
                    let token = JSON.parse(data.data.signInToForum.result)
                    if (cookie != token) {
                        console.log('cookie mismatch', cookie, token)
                        document.cookie = `_genod=${token}; domain=.genoplot.com; expires=Sun, 1 Jan 2033 00:00:00 UTC; path=/`
                        this.$store.commit('change', {
                            genod: token
                        })
                        w.$eventBus.$emit('appEvents', {
                            exec: 'reloadForum',
                            component: 'discussions',
                        })
                    }
                }
            } else {
                if (cookie) {
                    document.cookie = `_genod=; domain=.genoplot.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
                    this.$store.commit('change', {
                        genod: false
                    })
                    w.$eventBus.$emit('appEvents', {
                        exec: 'reloadForum',
                        component: 'discussions',
                    })
                }
            }
        },
        deleteAllCookies() {
            var cookies = document.cookie.split(";");

            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i];
                var eqPos = cookie.indexOf("=");
                var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
        },
        routeChange: function(params) {
            console.log('route change');
            this.checkSub('route');
            requestIdleCallback(async () => {
                await this.getUser()
                this.showshare = false;
                this.src = false;
                if (this.user && this.user.username) {
                    this.broadcast.postMessage('checkUpdates');
                    if (this.$genericevent) this.$genericevent.shutdown();
                    if (this.$genericevent) this.$genericevent.boot({
                        user_id: this.user.username,
                        name: this.user.username,
                        email: this.user.email,
                        created_at: this.userCreated ? this.userCreated : undefined,
                        Plan: this.subPlan,
                        VIP: this.VIP || false,
                        MFA: this.user.MFA,
                        Credits: this.credits,
                        Renewal: this.renewal,
                        SubRenewal: this.subRenewal,
                        version: this.$genoVer,
                        user_hash: this.intercomhash,
                        last_request_at: parseInt((new Date()).getTime() / 1000)
                    });
                    if (this.messages && this.messages > 0 && this.$route && this.$route.name == 'discussions' && params && params.from) {
                        this.resetMessages()
                    }
                    this.updateStatus(params);
                }
            })
        },
        updateStatus: async function(params) {
            let status = {}
            status.userid = this.user.username
            status.lastactivity = Math.round(Date.now() / 1000);
            status.credits = this.credits;
            status.planType = this.subPlan;
            status.version = this.$genoVer;
            if (this.subscription && this.subscription.renewal) status.renewal = this.subscription.renewal
            if (this.subscription && this.subscription.subRenewal) status.subRenewal = this.subscription.subRenewal
            if (this.rawSamplesCount) status.rawsamples = this.rawSamplesCount
            if (this.samplesCount) status.samples = this.samplesCount
            if (this.calcCount) status.calculators = this.calcCount
            if (this.$route && this.$route.name) status.route = this.$route.name
            if (this.alias) status.nickname = this.alias
            try {
                let updated = this.$apollo.mutate({
                    mutation: updateUserActivityMutation,
                    variables: {
                        input: status
                    }
                })
            } catch (err) {
                console.log(err);
            }
            let activity = {
                ...status
            }
            activity.mode = 'async';
            activity.action = 'trackActivity';
            activity.component = 'router'
            activity.function = 'routeChange'
            activity.to = params && params.to && params.to.name ? params.to.name : undefined
            activity.from = params && params.from && params.from.name ? params.from.name : undefined
            let theme = this.slider.theme && this.slider.theme.value && typeof(this.slider.theme.value) == 'string' ? this.slider.theme.value.toLowerCase() : 'system'
            activity.theme = theme;
            let meta = localStorage.getItem('devicemeta')
            try {
                let ranutility = localStorage.getItem(`ranUtility:${activity.userid}`)
                ranutility = JSON.parse(ranutility);
                if (ranutility) {
                    activity.deviceKey = ranutility.deviceKey
                    activity.mfa = ranutility.mfa
                    activity.name = ranutility.name
                }
                meta = meta ? JSON.parse(meta) : undefined
                if (!meta || !meta.ip) {
                    await this.getDeviceMeta();
                    meta = localStorage.getItem('devicemeta')
                } else {
                    meta = JSON.stringify(meta)
                }
            } catch (err) {
                console.log('meta err', err)
            }
            activity.meta = meta
            let fp = undefined
            if (this.thumbmark) {
                fp = this.thumbmark
            } else {
                try {
                    fp = await getFingerprint()
                    this.thumbmark = fp;
                    let end = Date.now()
                } catch (err) {
                    console.olog('fp err', err)
                }
            }
            activity.fp = fp;
            try {
                let query = getuserActivityQuery;
                const data = this.$apollo.query({
                    query: query,
                    variables: {
                        event: JSON.stringify(activity)
                    },
                    fetchPolicy: 'network-only'
                })
            } catch (err) {
                console.log(err);
            }
            if (window.twq) {
                twq('init', 'o4ka6');
                twq('track', 'PageView')
            };
        },
        closeIntercom() {
            if (this.$genericevent) this.$genericevent.hide()
        },
        showArticle(evt) {
            this.$genericevent.showArticle(evt);
        },
        recordEvent: function(evt, meta) {
            meta.component = this.component;
            let ignore = ['trackactivity', 'closeintercom', 'show', 'calculators', 'routechange', 'resettip', 'setcredits', 'refreshcache', 'getuser', 'rerun', 'reset', 'authevent', 'user_dimension', 'signedin', 'signedout']
            this.$gtag.event(evt, meta);
            if (ignore.indexOf(evt.toLowerCase()) < 0)
                if (this.$genericevent) this.$genericevent.trackEvent(evt, meta);
        },
        trackAuth: function(info) {
            let currentUser = this.user && this.user.username ? this.user.username : this.lastuser ? this.lastuser : 'NA'
            this.recordEvent('authEvent', {
                'event_category': 'authorization',
                'event_label': info
            })
        },
        trackAppEvents: function(info) {
            let ignore = ['trackactivity', 'closeintercom', 'show', 'calculators', 'routechange', 'resettip', 'setcredits', 'refreshcache', 'getuser', 'rerun', 'reset', 'authevent', 'user_dimension', 'signedin', 'signedout']
            if (typeof(info) === 'object' && info.component && info.exec && ignore.indexOf(info.exec.toLowerCase()) < 0) {
                this.recordEvent(info.exec, {
                    'event_category': 'function',
                    'event_label': typeof info.params === 'object' ? JSON.stringify(info.params) : info.params,
                    'event_component': info.component
                })
            }
        },
        execDefAction: function(evt) {
            if (evt == 'community' && this.$route.name == 'discussions') {
                let wn = document.getElementById('discussionframe').contentWindow;
                if (wn) {
                    console.log('sending message')
                    wn.postMessage({
                        action: 'navigate',
                        path: '/',
                        source: 'genoplot.com'
                    }, '*')
                }
            }
            let event = 'navbar-mobile';
            this.$root.$emit(event, 'close');
        },
        showAnalysis(params) {
            console.log('showAnalysis', params);
            if (params && params.path) {
                this.spinner = true;
                let value = this.slider.theme && this.slider.theme.value && typeof(this.slider.theme.value) == 'string' ? this.slider.theme.value.toLowerCase() : 'system'
                let genoTheme = this.getInitialColorMode(value)
                let share = `https://genoplot.com/shared/analysis/?share=${params.path}` + (genoTheme == 'dark' ? '#2' : '#1')
                this.navsrc = share;
                this.showNavShare = true;
            }
        },
        showHistory: function() {
            console.log('showing history', this.component);
            if (this.subType == 0) {
                this.recordEvent('tryHistory', {
                    'event_category': 'function',
                    'event_label': 'User initiated'
                })
                this.requiresSub('history')
            } else {
                this.recordEvent('showHistory', {
                    'event_category': 'function',
                    'event_label': 'User initiated'
                })
                let component = this.component
                console.log('showing history for ' + component);
                this.$modal.show('history-modal', {
                    component: component
                })
            }
        },
        checkSubStatus: function(params) {
            console.log('checking', params)
            if (params && params == 'addon') {
                console.log('adding credits')
                this.recordEvent('addCreditsButton', {
                    'event_category': 'function',
                    'event_label': 'User initiated'
                })
                let sub = this.subscription && this.subscription.subId ? this.subscription.subId : false
                if (sub) {
                    let expire = new Date(this.subscription.renewal)
                    let pastDate = new Date(expire);
                    pastDate.setDate(pastDate.getDate() - 1)
                    let expirestring = pastDate.toLocaleDateString()
                    this.$modal.show('purchase-addon-modal', {
                        subscriptionId: sub,
                        addonId: '500-add-on-credits-nr',
                        purchaseItem: 'Buy Credits',
                        addonName: 'Additional 500 credits',
                        subtext: `Note: credits do not rollover and will expire on ${expirestring}`,
                        amount: 500,
                        type: 'Credits',
                        unitPrice: 2.00,
                    })
                } else {
                    this.$modal.show('dialog', {
                        class: 'warning',
                        title: 'Error',
                        text: 'No active subscription'
                    })
                }
                return;
            }
            this.recordEvent('viewSubscriptions', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            let subscribed = localStorage.getItem(`${this.user.username}:subscribed`)
            if (this.subscription && !this.subscription.subId) {
                this.$modal.show('subscribe')
            } else if (this.subscription && this.subscription.subId || subscribed) {
                this.portal();
            } else {
                this.$modal.show('subscribe')
            }
        },
        showDemo: function() {
            this.$modal.show('demo-modal')
        },
        smallscreen: function() {},
        callDemo: function(item) {
            if (item === 'Demo') {
                this.recordEvent('runDemo', {
                    'event_category': 'function',
                    'event_label': this.user && this.user.username ? this.user.username : 'Not logged in'
                })
                this.recordEvent('runDemo', {
                    'event_category': 'interest',
                    'event_label': this.user && this.user.username ? this.user.username : 'Not logged in'
                })
            }
            this.recordEvent(item, {
                'event_category': 'views',
                'event_label': this.user && this.user.username ? this.user.username : 'Not logged in'
            })
            this.execDefAction();
            return
        },
        goToDiscussions: function() {
            this.execDefAction();
            return;
        },
        goHome: function() {
            this.execDefAction();
            return
            this.$router.push({
                name: 'landing',
                params: {
                    index: 0
                }
            })
        },
        setStatusMessage: function(params) {
            if (params.message && params.id && params.id === this.subId) {
                if (params.groups) {
                    this.execFunc({
                        exec: 'setGroupArray',
                        params: {
                            groups: params.groups
                        },
                        component: 'g25'
                    })
                }
                this.$store.commit('change', {
                    fadeIn: false
                });
                this.$store.commit('change', {
                    statusMessage: params.message
                });
                setTimeout(() => {
                    this.$store.commit('change', {
                        fadeIn: true
                    });
                }, 500)
            }
        },
        clearError: function() {
            this.error = false;
        },
        checkUserUpdate: function() {
            if (this.user && this.user.username) {
                this.creditUpdate = this.creditUpdate ? (this.creditUpdate + 1) % 10 : 0
                if (this.creditUpdate === 0) {
                    let credits = this.$store.getters.get('credits')
                    let now = Date.now()
                    if (credits !== this.lastcredits && now > (this.lastCreditUpdate + 300000)) {
                        if (this.$genericevent) this.$genericevent.update({
                            user_id: this.user.username,
                            Credits: credits
                        });
                        this.lastcredits = credits
                        this.lastCreditUpdate = now;
                    }
                }
                var midnight = new Date().setHours(0, 0, 0, 0) / 1000
                if ((!this.userUpdated || this.userUpdated && midnight > parseInt(this.userUpdated)) && this.signedIn && this.onLine) {
                    var user = {
                        userid: this.username,
                        lastUpdate: midnight
                    }
                    this.updateUser(user)
                }
            } else {
                clearInterval(this.checkUser)
            }
        },
        GetFormattedDate: function() {
            var format = function(str) {
                var str = "0" + str;
                var l = str.length;
                return (str.substring(l - 2, l))
            }
            var todayTime = new Date();
            var month = format(todayTime.getMonth() + 0);
            var day = format(todayTime.getDate());
            var year = (todayTime.getFullYear());
            //return month + "/" + day + "/" + year;
            return year + "-" + month + "-" + day;

        },
        clearStorage: function() {
            console.log('clearing storage');
            sessionStorage.clear()
            localStorage.clear();
            this.refreshPage()
        },
        show: function(params) {
            var w = this;
            var title = params.title ? params.title : 'Alert!'
            var text = params.text ? params.text : 'Message received...'
            var button = params.button ? params.button : 'OK'
            var buttons = [{
                title: button,
                default: true, // Will be triggered by default if 'Enter' pressed.
            }]
            if (params.closed && params.closed === 'clearError') {
                buttons.unshift({
                    title: 'Clear Error',
                    handler: () => {
                        if (params.closed) w[params.closed]();
                        this.$modal.hide('dialog')
                    } // Button click handler
                })
            }
            if (params.action && typeof(params.action) === 'object' && params.action.button && params.action.method) {
                var action = params.action
                buttons.unshift({
                    title: action.button,
                    handler: () => {
                        this[action.method](action.params)
                    }
                })
            }
            this.$modal.show('dialog', {
                title: title,
                text: text,
                class: params.class ? params.class : undefined,
                buttons: buttons,
                beforeClose: function(event) {
                    console.log('closed ', event)
                }
            })
        },
        checkUpdates: function() {
            this.broadcast.postMessage('checkUpdates');
            this.$modal.hide('dialog');
        },
        refreshPage: function() {
            setTimeout(() => {
                window.location.reload(true)
            }, 1000)
        },
        setCredits: function(params) {
            this.credits = params && params.value && params.value <= this.credits || params && params.value && params.value >= this.credits + 20 ? Math.floor(params.value) : this.credits;
            this.$store.commit('change', {
                credits: this.credits
            });
            let now = Date.now()
            if (this.credits !== this.lastcredits && now > (this.lastCreditUpdate + 300000)) {
                if (this.$genericevent) this.$genericevent.update({
                    user_id: this.user.username,
                    Credits: this.credits
                });
                this.lastcredits = this.credits
                this.lastCreditUpdate = now;
            }
        },
        reconnect: async function() {
            var w = this;
            w.disconnect();
            await reconnectAppSync();
            if (this.subscriptions && Object.keys(this.subscriptions) && Object.keys(this.subscriptions).length > 0) {
                this.lastSubAttempt = Date.now()
                var subs = Object.keys(this.subscriptions);
                console.log('active subscriptions ', subs);
                if (window.toastError) {
                    window.toastError.goAway()
                    delete window.toastError
                }
                var resub = function() {
                    subs.forEach(id => {
                        console.log('reconnecting subscription: ' + id)
                        w.pubsub(id, 0);
                    });
                    w.$store.commit('change', {
                        onLine: true
                    })
                    delete window.toastError
                    w.$store.commit('change', {
                        subsActive: true
                    });
                }
                console.log('verifying graphQL endpoint...');
                var retrying = 0;
                var pingUrl = function() {
                    w.$apollo.query({
                            query: pingAPIQuery,
                            context: {
                                timeout: 3000
                            },
                            fetchPolicy: 'network-only'
                        })
                        .then(data => {
                            resub();
                        }).catch(err => {
                            w.error = err.info && err.message ? err.info + err.message : err.message ? err.message : err
                        })
                }
                pingUrl();
            }
        },
        disconnect: function() {
            let w = this;
            if (this.subscriptions && Object.keys(this.subscriptions) && Object.keys(this.subscriptions).length > 0 && w.onLine) {
                this.$store.commit('change', {
                    subsActive: false
                });
                this.$store.commit('change', {
                    onLine: false
                });
                var subs = Object.keys(this.subscriptions);
                subs.forEach(id => {
                    console.log('disconnecting subscription: ' + id)
                    this.subscriptions[id].unsubscribe();
                })
            }
            if (!window.toastError) {
                window.toastError = this.$toasted.show(`${new Date().toLocaleString()}: Network Error<br/>Please check your internet connection`, {
                    position: 'bottom-center',
                    duration: null,
                    closeOnSwipe: false,
                    className: 'toastError',
                    theme: 'toasted-primary',
                    action: {
                        text: 'Details',
                        onClick: (e, toastObject) => {
                            w.getStatus()
                        }
                    }
                })
            } else {
            window.toastError.goAway()
            window.toastError.remove()
            delete window.toastError;
                window.toastError = this.$toasted.show(`${new Date().toLocaleString()}: Network Error<br/>Please check your internet connection`, {
                    position: 'bottom-center',
                    duration: null,
                    closeOnSwipe: false,
                    className: 'toastError',
                    theme: 'toasted-primary',
                    action: {
                        text: 'Details',
                        onClick: (e, toastObject) => {
                            w.getStatus()
                        }
                    }
                })
            }
            /* else {
                 delete window.toastError
                 window.toastError = this.$toasted.show('Error<br/>Please check your internet connection', {
                     position: 'bottom-left',
                     duration: null,
                     className: 'toastError',
                     theme: 'toasted-primary',
                     action: {
                         text: 'Details',
                         onClick: (e, toastObject) => {
                             w.getStatus()
                         }
                     }
                 })

             }
             */
        },
        handleProxyUser: function(evt) {
            let w = this;
            clearTimeout(w.debounce)
            w.debounce = setTimeout(() => {
                if (!evt || evt == '') {
                    w.proxyuser = w.user.username
                } else {
                    w.proxyuser = evt
                }
                w.$store.commit('change', {
                    proxyUser: w.proxyuser
                })
            }, 2000)
        },
        removeProxy: function(evt) {},
        reset: function() {
            return;
            let event = 'navbar-mobile';
            this.$root.$emit(event, 'close');
            var init = this.$store.getters.get('init')
            var a = this.$store.getters.get('sampleArray')
            var b = this.$store.getters.get('groupArray')
            var c = this.$store.getters.get('user')
            var d = this.$store.getters.get('subscription')
            var e = this.$store.getters.get('slider')
            var f = this.$store.getters.get('switches')
            var g = this.$store.getters.get('lastsync')
            this.$store.replaceState(JSON.parse(init));
            this.$store.commit('change', {
                init: init
            });
            this.$store.commit('change', {
                'sampleArray': a
            });
            this.$store.commit('change', {
                'groupArray': b
            });
            this.$store.commit('change', {
                'user': c
            });
            this.$store.commit('change', {
                'subscription': d
            });
            this.$store.commit('change', {
                'slider': e
            });
            this.$store.commit('change', {
                'switches': f
            });
            this.$store.commit('change', {
                'lastsync': g
            });
            this.execFunc({
                exec: 'fadeResults',
                component: 'g25'
            })
            return null;
            console.log('state reset...');
        },
        execFunc(remoteFunc) {
            this.$eventBus.$emit('appEvents', remoteFunc)
        },
        editProfile: function() {
            this.$modal.show('userprofile', {
                displayOnly: false
            })
        },
        customAction: function(evt) {
            this.$modal.show('VerifyMfaModal')
        },
        getStatus: function(evt) {
            if (this.$ddRum && evt && evt.rum) {
                if (this.rumSession) {
                    this.$ddRum.stopSessionReplayRecording()
                    clearTimeout(this.rumSession)
                    this.rumSession = false
                    console.log(`${new Date()} - stopped...`)
                }
                this.$ddRum.startSessionReplayRecording()
                console.log(`${new Date()} - started...`)
                this.rumSession = setTimeout(() => {
                    this.$ddRum.stopSessionReplayRecording()
                    this.rumSession = false
                    console.log(`${new Date()} - stopped`)
                }, 300000)
            } else {
                var title = "Current Status"
                var text = ''
                if (this.onLine && this.subsActive) {
                    var subs = Object.keys(this.subscriptions);
                    text = '<b style="color:green">application is online</b><br/><br/>active channels:<br/><b>'
                    subs.forEach(id => {
                        text = text + id.replace(/:/g, ' ► ') + "<br/>"
                    })
                    text = text + "</b>"
                    if (this.lastQuery) {
                        text = text + '<br/>' + this.lastQuery
                    }
                    if (this.error) {
                        try {
                            text = text + '<br/><b style="color:brown">Error: </b><b style="color:#444">&nbps;' + this.error.toString().substr(0, 256).replace('Error:', '') + '...</b>'
                        } catch (err) {
                            console.log(err)
                        }
                    }
                } else {
                    text = '<b style="color:brown" >application is offline</b><br/><br/>disonnected channels:<br/><b>'
                    var subs = Object.keys(this.subscriptions);
                    subs.forEach(id => {
                        text = text + id.replace(/:/g, ' : ') + "<br/>"
                    })
                    text = text + "</b>"
                    if (this.lastQuery && !this.error) {
                        text = text + '<br/>' + this.lastQuery
                    }
                    if (this.error) {
                        try {
                            text = text + '<br/><b style="color:brown">Error: </b><b style="color:#444">&nbsp;' + this.error.toString().substr(0, 256).replace('Error:', '') + '...<br/></b>'
                        } catch (err) {
                            console.log(err)
                        }
                    }
                }
                this.show({
                    title: title,
                    text: text + '<br>v' + this.$genoVer,
                    closed: this.error ? 'clearError' : undefined
                });
            }
        },

        pubsub: function(id, retry) {
            var w = this;
            console.log('subscribing to ' + id + ' on ' + new Date().toLocaleString());
            this.error = false;
            this.$store.commit('change', {
                subsActive: true
            });
            this.$store.commit('change', {
                onLine: true
            });
            const observable = this.$apollo.subscribe({
                query: onPublishMessageSub,
                retry: true,
                variables: {
                    id: id
                }
            });
            const executeAction = function executeAction(data) {
                if (!w.onLine) w.$store.commit('change', {
                    onLine: true
                });
                retry = retry === 0 ? 50 : retry >= 60000 ? 60000 : retry * 2;
                try {
                    if (data.data && data.data.onPublishMessage && data.data.onPublishMessage.message) {
                        var message = JSON.parse(data.data.onPublishMessage.message)
                        if (message.action && message.component) {
                            if (message.component == 'nav') {
                                try {
                                    console.log('exec', message.action, message.params)
                                    w[message.action](message.params)
                                } catch (err) {
                                    console.log(err);
                                }
                            } else {
                                w.$eventBus.$emit('appEvents', {
                                    exec: message.action,
                                    component: message.component,
                                    params: message.params ? message.params : undefined
                                })
                            }
                        }
                    } else {
                        console.log(err);
                        w.error = message
                        //w.$sentry.captureException(new Error(message));
                    }
                } catch (err) {
                    console.log(err);
                    if (w.onLine) w.$store.commit('change', {
                        onLine: false
                    });
                    w.$store.commit('change', {
                        subsActive: false
                    });
                    w.error = err.info && err.message ? err.info + err.message : err.message ? err.message : err
                    //w.$sentry.captureException(err);
                }
            }

            this.subscriptions[id] = observable.subscribe({
                next: executeAction,
                complete: console.log,
                connect: function(evt) {
                    console.log('connected ', evt)
                },
                error: function(err) {
                    console.log('subscription error: ', err)
                    w.error = err.info && err.message ? err.info + err.message : err.message ? err.message : err
                    w.reconnect()
                }
            })
        },
        getDefaultRoute: function(user) {
            let defaultRoute = localStorage.getItem(user + ':defaultRoute') ? localStorage.getItem(user + ':defaultRoute') : '/'
        },
        getUser: async function(user) {
            var w = this;
            let requireMFA = true;
            let params = user && user.params ? user.params : false;
            if (typeof(user) === 'undefined' || params) {
                var user = this.$store.getters.get('user') ? this.$store.getters.get('user').username : null;
            }
            if (this.$auth && this.$auth.currentAuthenticatedUser) {
                console.log('triggeredUser')
                let groups = await this.$auth.currentAuthenticatedUser({
                        bypassCache: true
                    })
                    .then(async user => {
                        let evt = {
                            name: user.username,
                            deviceKey: user.signInUserSession.accessToken.payload.device_key,
                        }
                        if (user.attributes) {
                            let attrs = {
                                ...user.attributes
                            }
                        }
                        if (user.signInUserSession && user.signInUserSession.idToken && user.signInUserSession.idToken.payload && user.signInUserSession.idToken.payload.discussToken) {
                            let token = params && params.discussToken ? params.discussToken : user.signInUserSession.idToken.payload.discussToken
                            document.cookie = `_genod=${token}; domain=.genoplot.com; expires=Sun, 1 Jan 2033 00:00:00 UTC; path=/`
                            w.$store.commit('change', {
                                genod: token
                            })
                        }
                        let groups = user.signInUserSession.idToken.payload["cognito:groups"] || []
                        let facebook = user.signInUserSession.idToken.payload['identities'] && user.signInUserSession.idToken.payload['identities'].some(x => x.providerName == 'Facebook') ? true : false
                        //console.log('user', user)
                        let email = !providerRegx.some(x => x.test(user.username)) && user.attributes && user.attributes.email ? user.attributes.email : user.signInUserSession.idToken.payload["email"];
                        user.username = !providerRegx.some(x => x.test(user.username)) ? user.username : user.signInUserSession.idToken.payload["preferred_username"] ? user.signInUserSession.idToken.payload["preferred_username"] : user.signInUserSession.idToken.payload['identities'].length ? (facebook ? email.split('@')[0] + 'x' : email.split('@')[0]) : user.username;
                        let mfa = user.preferredMFA && user.preferredMFA == "SOFTWARE_TOKEN_MFA" ? true : false
                        requireMFA = mfa ? false : true

                        if (user.attributes) {
                            user.attributes.email = email
                            user.attributes.MFA = mfa
                        } else {
                            user.attributes = {
                                email: email,
                                sub: user.signInUserSession.idToken.payload['sub'] ? user.signInUserSession.idToken.payload['sub'] : '',
                                MFA: mfa
                            }
                        }
                        try {
                            evt.username = user.username
                            evt.subid = user.attributes.sub
                            evt.mfa = user.attributes.MFA
                            evt.getUser = true
                            this.runUtility(evt);
                        } catch (err) {
                            console.log('runUtility getUser', err)
                        }
                        this.proxyuser = user.username
                        console.log('Groups: ', groups)
                        this.$store.commit('change', {
                            usergroups: groups
                        })
                        this.$store.commit('change', {
                            user: {
                                username: user.username,
                                sub: user.attributes.sub,
                                email: email,
                                MFA: mfa
                            }
                        });
                        if (user.signInUserSession.idToken.payload.forumToken) {
                            let token = user.signInUserSession.idToken.payload.forumToken;
                            this.$store.commit('change', {
                                peeruser: token
                            })
                        } else {
                            this.$store.commit('change', {
                                peeruser: false
                            })
                        }
                        if (this.$genericevent) this.$genericevent.update({
                            user_id: this.user.username,
                            MFA: mfa
                        });
                    })
            }
            let reset = typeof(user) === 'object' && user.reset ? true : false
            user = typeof(user) === 'object' ? user.userid : user;
            let tosDate = 0
            try {
                tosDate = localStorage.getItem('cacheVer') ? JSON.parse(localStorage.getItem('cacheVer')).tos : 0
            } catch (err) {}
            if (typeof(user) !== 'undefined') {
                let data = await this.$apollo.query({
                        query: getUserQuery,
                        variables: {
                            userid: user
                        },
                        options: {
                            fetchPolicy: 'no-cache'
                        },
                        fetchPolicy: 'no-cache'
                    })
                    .then(data => {
                        var sub = data.data && data.data.getUsers ? data.data.getUsers : false;
                        this.$store.commit('change', {
                            subscription: sub
                        })
                        if (sub && sub.messages) {
                            this.popMessage(sub.messages);
                        }
                        if (sub && sub.subId) localStorage.setItem(`${this.user.username}:subscribed`, true)
                        this.userCreated = sub && sub.created ? sub.created : false;
                        let annual = sub && sub.subType && sub.subType.includes('annual') || false
                        let subPlan = sub && sub.subType && sub.subType.substr(0, 3).toLowerCase() === 'gol' ? (annual ? 'ANNUALPRO' : 'PRO') : sub && sub.subType && sub.subType.substr(0, 3).toLowerCase() === 'sil' ? (annual ? 'ANNUALBASIC' : 'BASIC') : 'FREE'
                        this.subPlan = subPlan
                        requireMFA = sub.mfaRequired && requireMFA ? true : false;
                        this.VIP = sub.VIP || false
                        if (sub && sub.nickname && !sub.unaliased) {
                            console.log('setting alias', sub.nickname)
                            if (this.alias != sub.nickname) {
                                this.$eventBus.$emit('appEvents', {
                                    exec: 'init',
                                    component: 'global'
                                });
                            }
                            this.alias = sub.nickname
                        } else {
                            console.log('removing alias')
                            if (this.alias) {
                                this.$eventBus.$emit('appEvents', {
                                    exec: 'init',
                                    component: 'global'
                                });
                            }
                            this.alias = false
                        }
                        let renewal = sub.renewal ? new Date(Date.parse(sub.renewal)) : new Date(Date.parse('2000-01-01'))
                        this.renewal = renewal
                        let subRenewal = sub.subRenewal ? new Date(Date.parse(sub.subRenewal)) : new Date(Date.parse('2000-01-01'))
                        this.subRenewal = subRenewal
                        if ((this.subPlan && this.subPlan !== subPlan) || (this.renewal && this.renewal !== renewal)) {
                            if (this.user) {
                                let user = this.user;
                                if (this.$genericevent) this.$genericevent.update({
                                    user_id: user.username,
                                    name: user.username,
                                    email: user.email,
                                    created_at: this.userCreated ? this.userCreated : undefined,
                                    Plan: subPlan,
                                    VIP: this.VIP || false,
                                    Credits: this.credits,
                                    Renewal: this.renewal,
                                    version: this.$genoVer,
                                    SubRenewal: this.subRenewal
                                });
                                this.updateStatus();
                            }
                        }
                        if ((!sub.tos && !reset) || (sub.tos < tosDate && !reset)) {
                            this.$modal.show('tosmodal', {
                                displayOnly: false
                            })
                        } else if (!document.getElementById("tos")) {
                            //console.log('requireMFA status', requireMFA);
                            if (requireMFA && !document.getElementById("userprofile")) {
                                this.$modal.show('userprofile', {
                                    requireMFA: true
                                })
                            } else if (this.credits && sub && sub.credits && sub.credits > (this.credits + 10)) {
                                this.show({
                                    title: 'Account Status',
                                    text: `Your account now has ${sub.credits} compute credits!`,
                                    class: 'success'
                                })
                            }
                            this.credits = sub ? sub.credits : 99;
                            if (sub) {
                                this.$store.commit('change', {
                                    credits: this.credits
                                })
                                this.$store.commit('change', {
                                    subscription: sub
                                })
                                if (sub.subType) {
                                    /*if (window['zE']) {
                                let w = this;
            zESettings = { webWidget:{ contactForm: { fields: [ { id: 360047623713, prefill: { '*': w.subType === 2 ? 'PRO' :  w.subType === 1 ? 'BASIC' : 'FREE' } } ], tags: [w.username, w.subType === 2 ? 'PRO' :  w.subType === 1 ? 'BASIC' : 'FREE' ] }}}
                let identity = {
                  name: w.user && w.user.username ? w.user.username : w.username ? w.username : '',
                      email: w.usermail,
                            }
            this.$zendesk.identify(identity);
            this.$zendesk.prefill({
                        name: {
                            value: w.username,
                            readOnly: true // optional
                        },
                        Subscription: {
                        value: w.subType === 2 ? 'PRO' :  w.subType === 1 ? 'BASIC' : 'FREE'
                        },
                        email: {
                            value: w.usermail,
                            readOnly: true // optional
                        }
                    })
                    setTimeout(() => {
                        zE('webWidget', 'show')
                    }, 2000)
                }*/
                                }
                                if (sub.subType && sub.subType === 'free') {
                                    var slider = JSON.parse(JSON.stringify(this.slider))
                                    slider.batches.value = 200
                                    slider.cycles.value = 200
                                    slider.maxfits.value = 20
                                    this.$store.commit('change', {
                                        slider: slider
                                    })
                                    var name = this.username + ':' + 'slider'
                                    localStorage.setItem(name, JSON.stringify({
                                        slider: slider
                                    }));
                                }
                            } else {
                                var user = w.$store.getters.get('user').username;
                                var user = {
                                    userid: user,
                                    cognitoId: user,
                                    subType: 'free',
                                    renewal: this.GetFormattedDate(),
                                    lastUpdate: Math.round(Date.now() / 1000),
                                    created: Math.round(Date.now() / 1000)
                                }
                                console.log('creating user', user);
                                this.createUser(user)
                            }
                        }
                        if (sub && sub.notifications > 0 && this.$route && this.$route.name != 'discussions') {
                            this.messages = sub.notifications
                        } else if (sub && sub.notifications > 0 && this.$route && this.$route.name == 'discussions') {
                            this.resetMessages()
                        }
                    })
                    .catch(error => console.log('getuser', error && error.message ? error.message : error))
            } else {
                return false;
            }
        },
        updateUser: function(user) {
            let midnight = user.lastUpdate ? user.lastUpdate : false
            let reset = user.reset ? true : false
            delete user.reset;
            user.lastUpdate = Math.round(Date.now() / 1000);
            this.$apollo.mutate({
                    mutation: updateUserMutation,
                    variables: {
                        input: user
                    }
                })
                .then(data => {
                    console.log('User updated @ ' + new Date().toLocaleString())
                    if (midnight) this.$store.commit('change', {
                        userUpdated: midnight
                    })
                    this.getUser({
                        userid: user.userid,
                        reset: true
                    });
                })
                .catch(error => {
                    if (error && error.graphQLErrors && error.graphQLErrors[0] && error.graphQLErrors[0].errorType && error.graphQLErrors[0].errorType === "DynamoDB:ConditionalCheckFailedException") {
                        console.log('(1) err updating user', user, error);
                        this.createUser(user)
                    } else {
                        console.log('(2) err updating user', user, error);
                    }
                })
        },
        createUser: function(user) {
            this.$apollo.mutate({
                    mutation: createUserMutation,
                    variables: {
                        input: user
                    }
                })
                .then(data => {
                    console.log('appSync User created: ', data)
                    this.$store.commit('change', {
                        lastUpdate: user.lastUpdate
                    })
                })
                .catch(error => {
                    console.log('(3) err creating user', user, error);
                    console.log(error)
                })
        },
        upsertUser: function(user) {
            this.$apollo.query({
                    query: getUserQuery,
                    variables: {
                        input: user.username
                    }
                })
                .then(data => {})
                .catch(error => {
                    console.log('(4) err upserting user', user, error);
                    console.log(error)
                })
        },
        showProfile: function() {
            this.$auth.currentAuthenticatedUser()
                .then(user => {
                    let facebook = user.signInUserSession.idToken.payload['identities'] && user.signInUserSession.idToken.payload['identities'].some(x => x.providerName == 'Facebook') ? true : false
                    //let email = !providerRegx.some(x => x.test(user.username)) && user.attributes && user.attributes.email ? user.attributes.email : user.signInUserSession.idToken.payload["email"] && user.signInUserSession.idToken.payload['identities'] && user.signInUserSession.idToken.payload['identities'][0] && user.signInUserSession.idToken.payload['identities'][0] ? user.signInUserSession.idToken.payload["email"] : user.attributes.email;
                    let email = !providerRegx.some(x => x.test(user.username)) && user.attributes && user.attributes.email ? user.attributes.email : user.signInUserSession.idToken.payload["email"];
                    user.username = !providerRegx.some(x => x.test(user.username)) ? user.username : user.signInUserSession.idToken.payload["preferred_username"] ? user.signInUserSession.idToken.payload["preferred_username"] : user.signInUserSession.idToken.payload['identities'].length ? (facebook ? email.split('@')[0] + 'x' : email.split('@')[0]) : user.username;
                    let mfa = user.preferredMFA && user.preferredMFA == "SOFTWARE_TOKEN_MFA" ? true : false
                    if (user.attributes) {
                        user.attributes.email = email
                        user.attributes.mfa = mfa
                    } else {
                        user.attributes = {
                            email: email,
                            sub: user.signInUserSession.idToken.payload['sub'] ? user.signInUserSession.idToken.payload['sub'] : '',
                            MFA: mfa
                        }
                    }
                    let groups = user.signInUserSession.idToken.payload["cognito:groups"] || []
                    this.isAdmin = groups.indexOf('admin') >= 0 ? true : false
                    this.$store.commit('change', {
                        isAdmin: this.isAdmin
                    })
                    this.$store.commit('change', {
                        user: {
                            username: username,
                            sub: user.attributes.sub,
                            email: user.attributes.email,
                            MFA: mfa
                        }
                    });
                    sessionStorage.setItem('user', JSON.stringify(this.$store.getters.get('user')))
                    this.$modal.show('login')
                    if (user.signInUserSession.idToken.payload.forumToken) {
                        let token = user.signInUserSession.idToken.payload.forumToken;
                        this.$store.commit('change', {
                            peeruser: token
                        })
                    } else {
                        this.$store.commit('change', {
                            peeruser: false
                        })
                    }
                    if (this.$genericevent) this.$genericevent.update({
                        user_id: this.user.username,
                        MFA: mfa
                    });

                })
                .catch(() => {})
        },
        execToast: async function(options) {
            let w = this;
            if (options && options.toast && options.message) {
                let position = options.position || 'bottom-left';
                let duration = options.duration || null;
                let theme = options.theme || 'toasted-primary';
                let actions = [{
                    text: options.button || 'OK',
                    className: 'action',
                    onClick: (e, toastObject) => {
                        toastObject.goAway();
                        setTimeout(() => {
                            if (w[options.action]) {
                                w[options.action](options.params)
                            }
                        }, 500)
                    }
                }];
                let cancel = {
                    text: 'Cancel',
                    className: 'ok',
                    onClick: (e, toastObject) => {
                        toastObject.goAway();
                        if (localStorage.getItem(`lastToast`)) {
                            localStorage.removeItem(`lastToast`)
                        }
                    }
                }
                let className = options.className || 'toastError';
                let message = `<div class="notification">${options.message + (options.swipe ? '<br><p class="subtext">swipe to hide notification</p>' : '')}</div>`
                let thisToast = this.$toasted.show(message, {
                    position: position,
                    duration: duration,
                    closeIcon: true,
                    countdown: parseInt(options.countdown / 1000),
                    closeOnSwipe: options.swipe ? true : false,
                    className: className + ' execAction',
                    theme: theme,
                    action: actions
                })
                if (options.force && options.action && w[options.action]) {
                    setTimeout(() => {
                        if (options.clear) {
                            this.$toasted.clear()
                        } else {
                            thisToast.goAway();
                        }
                        w[options.action](options.params)
                    }, options.delay || 10000)
                }
            } else {
                console.log('no toast specified')
            }
        },
        showToast: async function(params) {
            let w = this;
            if (params && params.toast && params.message) {
                if (params.sendEvent) {
                    setTimeout(() => {
                        w.$eventBus.$emit(params.sendEvent.type, params.sendEvent)
                    }, 1000)
                }
                let position = params.position || 'bottom-left';
                let duration = params.duration || null;
                let theme = params.theme || 'toasted-primary';
                let action = params.action || [{
                        text: 'Cancel',
                        className: 'ok',
                        onClick: (e, toastObject) => {
                            toastObject.goAway();
                            if (localStorage.getItem(`lastToast`)) {
                                localStorage.removeItem(`lastToast`)
                            }
                        }
                    },
                    {
                        text: 'Contact Us',
                        className: 'contact',
                        onClick: (e, toastObject) => {
                            toastObject.goAway();
                            if (localStorage.getItem(`lastToast`)) {
                                localStorage.removeItem(`lastToast`)
                            }
                            w.contacted = true;
                            setTimeout(() => {
                                if (w.$intercom) w.$intercom.showMessages();
                            }, 500)
                        }
                    }
                ];
                let className = params.className || 'toastError';
                params.timestamp = Date.now();
                localStorage.setItem(`lastToast`, JSON.stringify(params))
                this.$toasted.show(params.message, {
                    position: position,
                    duration: duration,
                    className: className,
                    theme: theme,
                    action: action
                })
            } else {
                console.log('no toast specified')
            }
        },
        showModal: async function(params) {
            if (params && params.modal) {
                params.locked = params.locked ? true : false;
                if (params.pred) {
                    let results = await this[params.pred](params)
                    if (results) this.$modal.show(params.modal, results)
                } else {
                    this.$modal.show(params.modal, params)
                }
            } else {
                console.log('no modal specified')
            }
        },
        closeModal: function(params) {
            if (params && params.modal) {
                this.$modal.hide(params.modal)
            }
        },
        updateSubscription: function(subId) {
            var subId = subId;
            this.$auth.currentAuthenticatedUser()
                .then(user => {
                    let facebook = user.signInUserSession.idToken.payload['identities'] && user.signInUserSession.idToken.payload['identities'].some(x => x.providerName == 'Facebook') ? true : false
                    //let email = !providerRegx.some(x => x.test(user.username)) && user.attributes && user.attributes.email ? user.attributes.email : user.signInUserSession.idToken.payload["email"] && user.signInUserSession.idToken.payload['identities'] && user.signInUserSession.idToken.payload['identities'][0] && user.signInUserSession.idToken.payload['identities'][0] ? user.signInUserSession.idToken.payload["email"] : user.attributes.email;
                    let email = !providerRegx.some(x => x.test(user.username)) && user.attributes && user.attributes.email ? user.attributes.email : user.signInUserSession.idToken.payload["email"];
                    user.username = !providerRegx.some(x => x.test(user.username)) ? user.username : user.signInUserSession.idToken.payload["preferred_username"] ? user.signInUserSession.idToken.payload["preferred_username"] : user.signInUserSession.idToken.payload['identities'].length ? (facebook ? email.split('@')[0] + 'x' : email.split('@')[0]) : user.username;
                    let mfa = user.preferredMFA && user.preferredMFA == "SOFTWARE_TOKEN_MFA" ? true : false
                    if (this.$genericevent) this.$genericevent.update({
                        user_id: this.user.username,
                        MFA: mfa
                    });

                    if (user.attributes) {
                        user.attributes.email = email
                        user.attributes.mfa = mfa
                    } else {
                        user.attributes = {
                            email: email,
                            sub: user.signInUserSession.idToken.payload['sub'] ? user.signInUserSession.idToken.payload['sub'] : '',
                            MFA: mfa
                        }
                    }
                    var token = user.signInUserSession.idToken.jwtToken
                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                    console.log('updating sub ', {
                        subId: subId,
                        method: 'subChanged'
                    })
                    axios.post("/api/subs/", {
                        subId: subId,
                        method: 'subChanged'
                    }, {
                        headers: headers
                    }).then(data => {
                        if (data.data) {
                            console.log('updated subscription');
                        }
                    }).catch(err => {
                        console.log(err);
                    })
                })
        },
        signIn: function(event) {
            let evt = 'navbar-mobile';
            this.$root.$emit(evt, 'close');
            this.$eventBus.$emit('authState', 'signIn')
        },
        signUp: function(event) {
            let evt = 'navbar-mobile';
            this.$root.$emit(evt, 'close');
            this.$eventBus.$emit('authState', 'signUp')
        },
        signOut: async function(event, reset) {
            if (event && event.exclude && event.exclude == this.excludeRemote) {
                console.log(`Excluding session from remote action`)
                return;
            }
            this.showNavShare = false;
            setTimeout(() => {
                this.navsrc = false;
            }, 1000)
            let showlogin = event && event.exec && event.exec == 'signIn' ? true : false
            console.log('signing out', event);
            var subs = Object.keys(this.subscriptions);
            subs.forEach(id => {
                console.log('disconnecting subscription: ' + id)
                this.subscriptions[id].unsubscribe();
            })
            if (this.user && this.user.username) {
                localStorage.removeItem(`ranUtility:${this.user.username}`)
                if (!event || !event.auto) {
                    this.excludeRemote = Date.now().toString(16) + Math.floor(Math.random() * 100).toString(16)
                    let options = {
                        mutation: publishMessage,
                        variables: {
                            message: {
                                id: `genoplot:user:${this.user.username}`,
                                message: JSON.stringify({
                                    action: 'signOut',
                                    params: {
                                        exclude: this.excludeRemote
                                    },
                                    component: 'nav'
                                })
                            }
                        },
                        fetchPolicy: 'no-cache'
                    }
                    //const exec = await this.$apollo.mutate(options)
                }
            }
            this.$store.commit('change', {
                peeruser: false
            })
            this.$store.commit('change', {
                user: false
            })
            let evt = 'navbar-mobile';
            this.$root.$emit(evt, 'close');
            if (this.$genericevent) this.$genericevent.shutdown();
            this.userstate = false;
            if (this.$genericevent) this.$genericevent.boot();
            try {
                await this.$auth.signOut()
            } catch (err) {
                console.log('Signout error', err)
            }
            console.log('User signed out');
            this.$eventBus.$emit('appEvents', {
                exec: 'unloadForum',
                component: 'discussions',
                params: 'log'
            })
            this.recordEvent('signedOut', {
                'event_category': 'authorization',
                'event_label': this.username
            })
            if (window.zE) {
                zE('webWidget', 'reset')
                zE.hide();
            }
            localStorage.removeItem(`${this.user.username}:subscribed`)
            if (this.$route && this.$route.meta && this.$route.meta.requiresAuth) {
                this.$router.push('/')
            }
            document.cookie = `_genod=; domain=.genoplot.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
            this.to = false;
            this.username = null;
            this.usermail = null;
            this.$store.commit('change', {
                user: false
            });
            sessionStorage.removeItem('user')
            this.$store.commit('change', {
                lastsync: false
            });
            this.$store.commit('change', {
                genod: false
            })
            try {
                setTimeout(() => {
                    sessionStorage.clear()
                }, 1000)
                /*
                let init = this.$store.getters.get('init')
                consoole.log('getting init', init);
                if (init) {
                    try {
                        console.log('resetting state')
                        this.$store.replaceState(JSON.parse(init));
                    } catch (err) {
                        console.log(err)
                    }
                }
                setTimeout(() => {
                    this.$store.commit('change', {
                        init: init
                    });
                }, 1000)
                this.$localForage.clear().then(function() {
                    console.log("Should clear db");
                }).catch(err => {
                    console.log(err);
                })
                */
            } catch (e) {
                console.log(JSON.stringify(e));
            }
            this.$eventBus.$emit('authState', 'signedOut')
            try {
                let w = this;
                w.$apolloClient.clearStore().then(() => {
                    w.$apolloClient.resetStore()
                })
            } catch (err) {
                console.log(err)
            }
            this.logoutForum()
            if (showlogin) this.signIn()
            return;
        },
        setError: function(e) {
            this.error = this.$Amplify.I18n.get(e.message || e);
        },
        portal: function(event) {
            if (typeof(Chargebee) == 'undefined') {
                var vm = this;
                const el = document.createElement('script')
                el.setAttribute('src', 'https://js.chargebee.com/v2/chargebee.js')
                el.onload = () => {
                    Chargebee.init({
                        site: 'genoplot',
                        iframeOnly: true
                    })
                    initPortal()
                }
                document.body.appendChild(el)
            } else {
                var vm = this;
                initPortal()
            }

            function initPortal() {
                vm.cbInstance = window.Chargebee.getInstance();
                vm.$auth.currentAuthenticatedUser()
                    .then(user => {
                        let facebook = user.signInUserSession.idToken.payload['identities'] && user.signInUserSession.idToken.payload['identities'].some(x => x.providerName == 'Facebook') ? true : false
                        //let email = !providerRegx.some(x => x.test(user.username)) && user.attributes && user.attributes.email ? user.attributes.email : user.signInUserSession.idToken.payload["email"] && user.signInUserSession.idToken.payload['identities'] && user.signInUserSession.idToken.payload['identities'][0] && user.signInUserSession.idToken.payload['identities'][0] ? user.signInUserSession.idToken.payload["email"] : user.attributes.email;
                        let email = !providerRegx.some(x => x.test(user.username)) && user.attributes && user.attributes.email ? user.attributes.email : user.signInUserSession.idToken.payload["email"];
                        user.username = !providerRegx.some(x => x.test(user.username)) ? user.username : user.signInUserSession.idToken.payload["preferred_username"] ? user.signInUserSession.idToken.payload["preferred_username"] : user.signInUserSession.idToken.payload['identities'].length ? (facebook ? email.split('@')[0] + 'x' : email.split('@')[0]) : user.username;
                        let mfa = user.preferredMFA && user.preferredMFA == "SOFTWARE_TOKEN_MFA" ? true : false
                        if (vm.$genericevent) vm.$genericevent.update({
                            user_id: vm.user.username,
                            MFA: mfa
                        });

                        if (user.attributes) {
                            user.attributes.email = email
                            user.attributes.mfa = mfa
                        } else {
                            user.attributes = {
                                email: email,
                                sub: user.signInUserSession.idToken.payload['sub'] ? user.signInUserSession.idToken.payload['sub'] : '',
                                MFA: mfa
                            }
                        }
                        let userid = user.username;
                        var token = user.signInUserSession.idToken.jwtToken
                        var updateUser = vm.updateUser;
                        var cbInstance = vm.cbInstance;
                        let username = userid;
                        if (username.length <= 3) {
                            username = '~~~' + username
                            username = username.slice(-4)
                        }
                        email = user.attributes.email
                        var customer = {
                            id: username,
                            email: email,
                            cf_nickname: username
                        };
                        var customer_id = customer.id;
                        vm.cbInstance.setPortalSession(async function() {
                            try {
                                let data = await vm.$apollo.query({
                                    query: getChargebeeSession,
                                    variables: {
                                        params: JSON.stringify({
                                            userid: customer_id,
                                            method: 'getSession'
                                        })
                                    },
                                    fetchPolicy: 'network-only'
                                })
                                if (data && data.data && data.data.getChargebeeSession) {
                                    console.log('session', data.data.getChargebeeSession);
                                    return (data.data.getChargebeeSession)
                                } else {
                                    console.log(data)
                                }
                            } catch (err) {
                                console.log(err)
                            }
                            /*
                                        var promise = new Promise(function(resolve, reject) {
                                            axios.post("/api/subs", {
                                                userid: customer_id,
                                                method: 'getSession'
                                            }, {
                                                headers: headers
                                            }).then(data => {
                                                if (data.data) {
                                                    console.log('session', data.data);
                                                    resolve(data.data)
                                                } else {
                                                    console.log(data);
                                                    reject(data)
                                                }
                                            }).catch(err => {
                                                console.log(err)
                                                reject(err)
                                            })
                                        });
                                        return promise;
                                        */
                        })
                        let cbPortal = vm.cbInstance.createChargebeePortal();
                        cbPortal.open({
                            close() {},
                            subscriptionCancelled: function(data) {
                                console.log('cancel', data)
                                vm.updateSubscription(data.subscription.id)
                            },
                            subscriptionChanged: function(data) {
                                console.log('changed', data)
                                //vm.updateSubscription(data.subscription.id)
                            }
                        });
                    })
            }
        },
        subscribe: function(plan) {
            let addon = false
            if (plan.split(':').length > 1) {
                addon = plan.split(':')[1]
                plan = plan.split(':')[0]
            }
            console.log('subscribe', plan);
            var plan = typeof(plan) === undefined ? "silver-monthly-plan" : plan;
            if (typeof(Chargebee) == 'undefined') {
                var vm = this;
                const el = document.createElement('script')
                el.setAttribute('src', 'https://js.chargebee.com/v2/chargebee.js')
                el.onload = () => {
                    Chargebee.init({
                        site: 'genoplot',
                        iframeOnly: true
                    })
                    initSub()
                }
                document.body.appendChild(el)
            } else {
                var vm = this;
                initSub()
            }

            function initSub() {
                vm.cbInstance = window.Chargebee.getInstance();
                vm.$auth.currentAuthenticatedUser()
                    .then(user => {
                        vm.$modal.hide('subscribe');
                        let facebook = user.signInUserSession.idToken.payload['identities'] && user.signInUserSession.idToken.payload['identities'].some(x => x.providerName == 'Facebook') ? true : false
                        //let email = !providerRegx.some(x => x.test(user.username)) && user.attributes && user.attributes.email ? user.attributes.email : user.signInUserSession.idToken.payload["email"] && user.signInUserSession.idToken.payload['identities'] && user.signInUserSession.idToken.payload['identities'][0] && user.signInUserSession.idToken.payload['identities'][0] ? user.signInUserSession.idToken.payload["email"] : user.attributes.email;
                        let email = !providerRegx.some(x => x.test(user.username)) && user.attributes && user.attributes.email ? user.attributes.email : user.signInUserSession.idToken.payload["email"];
                        user.username = !providerRegx.some(x => x.test(user.username)) ? user.username : user.signInUserSession.idToken.payload["preferred_username"] ? user.signInUserSession.idToken.payload["preferred_username"] : user.signInUserSession.idToken.payload['identities'].length ? (facebook ? email.split('@')[0] + 'x' : email.split('@')[0]) : user.username;
                        if (user.attributes) {
                            user.attributes.email = email
                        } else {
                            user.attributes = {
                                email: email,
                                sub: user.signInUserSession.idToken.payload['sub'] ? user.signInUserSession.idToken.payload['sub'] : ''
                            }
                        }
                        let userid = user.username;
                        var updateUser = vm.updateUser;
                        var cbInstance = vm.cbInstance;
                        let product = cbInstance.initializeProduct(plan);
                        cbInstance.setCheckoutCallbacks(function(cart) {
                            return {
                                success: function(hostedPageId, data) {
                                    if (data && data.subscription && data.subscription.id) {
                                        var sub = data.subscription
                                        var credits = sub.plan_id.indexOf('gold') >= 0 ? 3000 : 1000
                                        var user = {
                                            userid: userid,
                                            cognitoId: userid,
                                            renewal: vm.GetFormattedDate(),
                                            subId: sub.id,
                                            lastUpdate: Math.round(Date.now() / 1000),
                                            active: sub.status === 'active' ? 1 : 0,
                                            subType: sub.plan_id
                                        }
                                        console.log('User subscription retrieved: ', sub);
                                        vm.$store.commit('change', {
                                            subscription: user
                                        });
                                        updateUser(user);
                                        vm.recordEvent('subscribed', {
                                            'event_category': 'purchases',
                                            'event_label': sub.plan_id
                                        })
                                        vm.$gtag.purchase({
                                            "invoice_id": data.invoice.id,
                                            "affiliation": "chargebee",
                                            "currency_code": data.invoice.currency_code,
                                            "value": parseFloat(data.invoice.formatted_total),
                                            "customer": data.subscription.customer_id
                                        })
                                    }
                                    cbInstance.closeAll()
                                    vm.$modal.hide('subscribe');

                                }
                            }
                        });
                        let cart = cbInstance.getCart();
                        let username = user.username;
                        if (username.length <= 3) {
                            username = '~~~' + username
                            username = username.slice(-4)
                        }
                        email = user.attributes.email
                        var customer = {
                            id: username,
                            email: email,
                            cf_nickname: username
                        };
                        cart.setCustomer(customer);
                        cart.replaceProduct(product);
                        cart.proceedToCheckout();
                    })
                    .catch((e) => {
                        vm.$modal.hide('subscribe');
                        console.log(e);
                    })
            }
        }
    }
}
